import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.string.starts-with.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'web-animations-js'; // polyfill
import Drip from 'drip';
import Store from 'drip/store';
import Geo from 'drip/geo';
import KNB from '@dp/knb';
import Analytics from '@/utils/Analytics';
import openApp, { isProd } from '@/utils/openApp';
import * as detailComponentsNew from '@/components/detail-new';
import { pageTo } from '@/utils/comment';
import { Toast, SessionList, GoOrderPage, PromotionList, Home, ServiceTitleList, OutdatedError, SeeLabel, KugouMusic, FoldCard } from '@/components/common';
import LimitPage from 'comp/common/limit/LimitPage';
import LimitModal from 'comp/common/limit/LimitModal';
import throttle from '@/utils/throttle';
import Url from 'drip/utils/url';
import { getDetailShareLink } from '@/utils/shareUrl';
import { isLLCloseWebview } from '@/utils/closeWebview';
import Announcement from 'comp/announcement';
import { getDetail, getRecommends, getCollectState, addCollect, cancelCollect, getMsitePlaforms, getQRCode, getShowInfo, getAreaInfo, getIsNeedAnswerNew, checkActivityPermission, getReminderNumber, validateActivity, validateLOL, getHotComment, getkugouMusicList, statsPvReport, getGroupBuyApi } from '@/request/detail-new/index';
import { SHARE_CALLBACK } from '@/apis/';
import anchorMixins from '../mixins/pages/detail/anchor';
import adMixins from '../mixins/pages/detail/ad';
import { formatDate } from '@/utils/formatDate';
import GoodsList from '@/pages/goodsList/index';
import Vue from 'vue';
import BUTTONSTATUS from 'enums/detail-button-status';
import axios from '@/common/axios.mobile.js';
// TODO: 这个文件超大，要么自己写，至少不能全局引用
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import { LimitObjectConfig, LIMIT_CODE, HAS_COUNTTIME_LIMIT_CODE, NO_COUNTTIME_LIMIT_CODE } from '@/common/index';
import { getLionConfig } from '@/common/lionConfig';
import HotComment from '@/components/comments/HotComment.vue';
// TODO，样式修改
import CommentScoreCard from '@/components/comments/CommentScoreCard';
// import TipToComment from 'comp/comments/TipToComment'
import NpcList from '@/components/detail-new/npc-list';
import ShowListModal from '@/components/detail-new/show-list-modal.vue';

// 新页面组件 start
import BasicInfo from './detail/components/BasicInfo';
import Discount from './detail/components/Discount.vue';
import ShowTime from './detail/components/ShowTime.vue';
import ShowAddress from './detail/components/ShowAddress.vue';
import ServeiceTitle from './detail/components/ServiceTitle.vue';
import Comment from './detail/components/Comment.vue';
import GrabTickets from './detail/components/GrabTickets.vue';
import PreSale from './detail/components/PreSale.vue';
import Privilege from './detail/components/Privilege.vue';
import DetailAd from './detail/components/DetailAd.vue';
import GroupBuying from './detail/components/group-buying/index.vue';
import DelayNotice from './detail/components/DelayNotice.vue';
import ProjectCollectButton from './detail/components/ProjectCollectButton.vue';
import BuyInstruction from './detail/components/BuyInstruction.vue';
import WantToSee from './detail/components/WantToSee.vue';
import CalendarAndriod from '@/components/pre-modal/calendarAndriod.vue';
import CalendarSuccess from '@/components/pre-modal/calendarSuccess.vue';
import { notifyCalendar } from '@/utils/notifyCalendar';
import { submitRemind } from '@/request/detail-new/index';
import { categoryMapToPtChannelId } from '@/constants/categories';
import { imgCut } from '@/utils/filters';
import compositionApi, { ref } from '@vue/composition-api';
import { canGetSSLInfo, getSSLCA } from '@/utils/ssl';
Vue.use(compositionApi);
// 新页面组件 end
Vue.use(preview, {
  fullscreenEl: false
});
var selloutEnums = {
  REGISTERED: '缺货登记',
  UNREGISTERED: '售罄'
};
export default {
  name: 'detail-new',
  mixins: [anchorMixins, adMixins],
  components: Object.assign({}, detailComponentsNew, {
    PromotionList: PromotionList,
    ServiceTitleList: ServiceTitleList,
    SessionList: SessionList,
    OutdatedError: OutdatedError,
    GoOrderPage: GoOrderPage,
    Home: Home,
    LimitPage: LimitPage,
    LimitModal: LimitModal,
    SeeLabel: SeeLabel,
    Toast: Toast,
    GoodsList: GoodsList,
    Announcement: Announcement,
    CommentScoreCard: CommentScoreCard,
    // TipToComment,
    KugouMusic: KugouMusic,
    HotComment: HotComment,
    FoldCard: FoldCard,
    NpcList: NpcList,
    ShowListModal: ShowListModal,
    BasicInfo: BasicInfo,
    Discount: Discount,
    ShowTime: ShowTime,
    ShowAddress: ShowAddress,
    ServeiceTitle: ServeiceTitle,
    Comment: Comment,
    GrabTickets: GrabTickets,
    PreSale: PreSale,
    Privilege: Privilege,
    DetailAd: DetailAd,
    DelayNotice: DelayNotice,
    ProjectCollectButton: ProjectCollectButton,
    BuyInstruction: BuyInstruction,
    WantToSee: WantToSee,
    CalendarAndriod: CalendarAndriod,
    CalendarSuccess: CalendarSuccess,
    GroupBuying: GroupBuying
  }),
  setup: function setup() {
    /**
     * 演出团购
     */
    var groupBuyingList = ref([]);
    var getGroupBy = function getGroupBy(projectId) {
      getGroupBuyApi(projectId).then(function (res) {
        groupBuyingList.value = res.data || [];
      }).catch(function (err) {
        console.warn(err);
      });
    };
    return {
      groupBuyingList: groupBuyingList,
      getGroupBy: getGroupBy
    };
  },
  beforeCreate: function beforeCreate() {
    KNB.ready(function () {
      Geo.getCity();
      Geo.getLocCity();
    });
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var hasRelaod, city, utm_content, mtHistoryObj;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            Store.remove('detailPageShouldReload');
            Store.remove('routeFrom');
            _this.Env.setTitle(!Drip.UA.IS_TENGJING ? '猫眼演出详情' : '赛事详情');
            if (!Drip.UA.isNative) {
              _context2.next = 9;
              break;
            }
            if (!canGetSSLInfo()) {
              _context2.next = 8;
              break;
            }
            _context2.next = 7;
            return getSSLCA();
          case 7:
            _this.encryptCertificateString = _context2.sent;
          case 8:
            KNB.subscribe({
              action: 'appear',
              handle: function () {
                var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var shouldReload, routeFrom, calanderBack;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _this.getValidateResult();
                        //sqt待优化
                        _this.handleGetHotComment();
                        _context.next = 4;
                        return Store.get('detailPageShouldReload');
                      case 4:
                        shouldReload = !!_context.sent;
                        _context.next = 7;
                        return Store.get('routeFrom');
                      case 7:
                        routeFrom = _context.sent;
                        // 刷新接口更细已预约和已填写状态
                        if (shouldReload) {
                          _this.start(true);
                          Store.remove('detailPageShouldReload');
                        }
                        if (!(Drip.UA.osName === 'android')) {
                          _context.next = 17;
                          break;
                        }
                        _context.next = 12;
                        return Store.get('setCalendar');
                      case 12:
                        calanderBack = !!_context.sent;
                        if (!calanderBack) {
                          _context.next = 17;
                          break;
                        }
                        _context.next = 16;
                        return Store.remove('setCalendar');
                      case 16:
                        _this.isShowRemindModal = true;
                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                function handle() {
                  return _handle.apply(this, arguments);
                }
                return handle;
              }()
            });
          case 9:
            if (Drip.constant.cityId) {
              _this.cityId = Drip.constant.cityId;
            }
            // 截流
            _this.checkMSiteAndButtonRreaction = _this.throttle(_this.checkMSiteAndCallback(_this.checkSellChannelAndNavigateToQRCodePage(_this.checkLoginReaction(_this.buttonReaction))), 500);
            _this.openPrivilege = _this.throttle(_this.openPrivilege, 600);
            _this.checkMSiteAndPrefillClick = _this.checkMSiteAndCallback(_this.prefillClick);
            hasRelaod = _this.checkAndReload(); // pv 打点
            city = {};
            _context2.prev = 15;
            _context2.next = 18;
            return Geo.getCity();
          case 18:
            city = _context2.sent;
            _context2.next = 24;
            break;
          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](15);
            console.log(' getCity error', _context2.t0);
          case 24:
            utm_content = Url.getQuery('utm_source') || Url.getHashQuery('utm_source') || ''; // 打点custom里带的基础参数
            _this.customStatusObject = {
              id: _this.performanceId || _this.performanceIdByRoute,
              performance_id: _this.performanceId || _this.performanceIdByRoute,
              city_id: city && city.cityId || 1,
              userId: Drip.User.userId,
              utm_content: utm_content.includes('MYYCTF') ? utm_content : ''
            };
            Analytics('c_c21utqjf', Drip.User.userId, {
              custom: Object.assign({}, _this.customStatusObject, {
                abtest: 0
              }),
              global: {
                abtest: 0,
                custom: Object.assign({}, _this.customStatusObject)
              }
            }, undefined, true);
            if (hasRelaod) {
              _context2.next = 34;
              break;
            }
            try {
              _this.handleGetHotComment(); // 获取评论列表
            } catch (e) {
              console.warn(e);
            }
            _this.$loading();
            _context2.next = 32;
            return _this.start();
          case 32:
            mtHistoryObj = {
              'pt_channel_pv_third': categoryMapToPtChannelId[_this.performanceInfo.categoryId]
            };
            Analytics('c_c21utqjf', Drip.User.userId, {
              custom: Object.assign({}, _this.customStatusObject, {
                abtest: 0
              }),
              global: {
                abtest: 0,
                custom: Object.assign({}, _this.customStatusObject)
              }
            }, undefined, true, mtHistoryObj);
          case 34:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[15, 21]]);
    }))();
  },
  data: function data() {
    var _Drip$UA;
    return {
      remindRes: {},
      calendarSuccessVis: false,
      calendarAndriodVis: false,
      bindMobile: '',
      remindeSource: false,
      selloutEnums: selloutEnums,
      toSellToast: false,
      toSellText: '',
      pageUnMounted: false,
      pageInit: false,
      pageInitErr: false,
      pageInitErrType: '',
      // 商家自销（非主办自销）已下架，为保险先注释，没问题后可删
      // isSalesWay: false,
      closeWebview: false,
      // 关闭webView时判定是否使用knb设置返回按钮
      saleRemind: {
        phone: '',
        isSubmitable: false
      },
      // 是否有网络
      isOnline: true,
      timer: null,
      isMSite: false,
      mPreview: false,
      // m站 且 开且预览功能（m站共鞥）
      isWxWbQQ: false,
      showMTutorial: false,
      // 是否展示m站普通浏览器引导弹窗
      showMJumpModal: false,
      // 是否展示m站引导跳转弹窗
      showMCode: false,
      // 是否展示m站引导小程序二维码
      MPlatforms: {
        miniapp: false,
        platforms: []
      },
      prompt: {
        // 弹窗信息
        show: false,
        text: '去验证',
        content: '',
        type: ''
      },
      mQRcode: '',
      // 二维码链接
      shareOptions: {},
      // 分享
      /**
      * 1 展览单场次模版
      * 2 展览非日历模版
      * 3 展览日历模版
      * 4 剧类模版
      * 5 剧类日历模版
      */
      ticketModels: [1, 2, 3, 4, 5],
      performanceInfo: {},
      // 演出数据
      recommandList: [],
      // 推荐列表
      tapStatus: '',
      isShowCountDownComponent: false,
      isShowPreSaleTitle: false,
      isShowRemindText: false,
      isSeatPreview: false,
      // 座位预览是否正在显示
      isShowPromotion: false,
      // 优惠详情是否正在显示
      isShowServiceTitle: false,
      // 服务标是否正在显示
      isShowServiceTitleBar: false,
      // 头部的服务标栏是否展示
      isLogin: false,
      isCollect: false,
      // 是否收藏
      isCollecting: false,
      activitiesInfo: {},
      // 外部活动信息
      outSideCheckUrl: '',
      // 外部活动或第三方验证页面链接
      mistiming: 0,
      // 网络延迟时间
      currentTime: new Date().getTime(),
      now: 0,
      // 准确的服务器当前时间
      saleStatus: 999,
      isSelectSeatProject: 999,
      // 是否选座
      isNeedOnSaleRemind: 999,
      // 是否需要开售提醒
      isNeedSoldOutRegister: 999,
      // 是否需要缺货提醒
      saleRemindVO: {},
      // 开售提醒数据（开售前数据)
      isShowRemindModal: false,
      // 打开开售提醒弹窗
      isNeedRemindWithPriceModal: false,
      // 开售提醒弹窗是否带有票档
      remindTicketPriceList: [],
      // 开售提醒弹窗中的票价信息
      remindNumber: '',
      // 开售提醒提交的号码
      showInfo: [],
      // 演出的场次信息
      isShowSessionList: false,
      // 是否展示多场次选择的弹窗
      countDownEnd: false,
      btnText: 'unknown',
      reaction: 'unknown',
      btnType: 'unknown',
      animateScroll: false,
      showBomb: true,
      throttleOnscroll: null,
      // 空function 用于removeEventListener
      detailComponentShowMask: false,
      lightComponentShowMask: false,
      isNeedDisplayGoIndex: false,
      isNeedDisplayGoOrder: false,
      // 常驻展示
      displayGoIndex: false,
      displayGoOrder: true,
      showLimitMask: false,
      isLimitPage: false,
      // 是否页面层面限流
      showLimitingModal: false,
      // 是否展示限流弹窗
      limitCount: 0,
      limitObject: {
        backgroundImage: '',
        // 限流页面底图
        hasCountTime: false,
        // 是否是倒计时
        defaultLimitTime: 0,
        // 限流倒计时
        buttonText: '',
        // 限流按钮文字
        text: '' // 限流content文字
      },

      isShowReminderPublic: false,
      // 是否显示预约公示
      isShowReminderPublicModal: true,
      // 是否显示预约公示弹窗
      reminderPublicNumber: 0,
      // 预约公示初始化人数
      projectReserveVO: {},
      // 预约公示相关
      reminderPublicModalSource: null,
      // 预约公示弹窗的背景图颜色二维码
      activityType: 0,
      // 项目类型 0-普通项目 1-粉丝特权购 2-会员购
      customStatusObject: {},
      // 打点custom里带的基础参数
      kingHonorFlag: false,
      // 判断当前项目是不是LOL项目
      isShowDelayPopup: false,
      // 展示项目延期提示框
      showMoreInfo: false,
      // 按钮展示更多信息
      externalActivity: false,
      // 判断是否是新的活动项目
      isTengjing: Drip.UA.IS_TENGJING,
      isMaidanba: Drip.UA.IS_MAIDANBA,
      isCmbApp: Drip.UA.IS_CMBAPP,
      isShenZhenICBC: (_Drip$UA = Drip.UA) === null || _Drip$UA === void 0 ? void 0 : _Drip$UA.IS_SHENZHEN_ICBC,
      lionData: {},
      // 演出 lion 配置
      commentInfo: {},
      // 评论详情
      kugoubaseInfo: {},
      // kugou音乐模块基础信息
      musicList: [],
      // kugou音乐列表
      // 是否展示拼场项目的场次弹层
      showListModal: false,
      // 是否开启新的页面展示
      showNewPage: false,
      // 是否展示精彩现场
      isShowWonderFul: false,
      // 是否展示延期取消模块
      showDelayNotice: false,
      // 是否展示详情banner模块
      showDetailAd: false,
      // 是否展示新购票须知
      showNewNotes: false,
      newNotesList: [],
      performanceDuration: '',
      // 演出时长
      needCloseRecommend: true,
      validateResult: false,
      cityId: null,
      straightLineDistance: undefined
    };
  },
  methods: {
    onCountDownFinish: function onCountDownFinish() {
      this.getGroupBy(this.performanceId);
    },
    iphoneClose: function iphoneClose(res) {
      this.calendarSuccessVis = false;
      this.remindModalSubmit(res);
    },
    // 获取热门评论列表
    handleGetHotComment: function handleGetHotComment() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var projectId, params, res, _ref, _ref$commentList, commentList;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Drip.UA.IS_DouyinShowMicroApp || Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE || Drip.UA.IS_MAOYAN_BAIDU_APP)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              projectId = _this2.performanceIdByRoute;
              params = {
                projectId: projectId,
                needUserComment: false,
                hotCommentLimit: 10
              };
              _context3.next = 6;
              return getHotComment(params);
            case 6:
              res = _context3.sent;
              if (res && res.data) {
                _this2.commentInfo = Object.assign({}, res.data);
                _ref = _this2.commentInfo.queryComments || {}, _ref$commentList = _ref.commentList, commentList = _ref$commentList === void 0 ? [] : _ref$commentList;
                commentList = commentList || [];
                // 热评只需要前两条展示
                _this2.commentInfo.commentList = commentList.length >= 2 ? commentList.slice(0, 2) : commentList;
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 前往评论列表
    toComment: function toComment() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      // type 1为我的评价列表，2为评论列表
      if (type === 2) {
        pageTo("/comments/list/".concat(this.performanceInfo.performanceId));
      } else {
        pageTo("/comments/myList/".concat(this.performanceInfo.performanceId));
      }
    },
    // 前往发表评价页面
    postComment: function postComment() {
      var _this3 = this;
      var self = this;
      if (!this.commentInfo.commentStatus) {
        return this.$toast('本次演出暂不支持发布评论');
      }
      // 未登陆时操作
      if (!this.isLogin) {
        return Drip.login().then(function () {
          if (!_this3.commentInfo.commented) {
            self.postComment();
          }
        }).catch(function (err) {
          console.warn(err);
        });
      }
      if (!this.commentInfo.commented) {
        var performanceInfo = this.performanceInfo;
        if (performanceInfo && performanceInfo.performanceId) {
          var IS_MEITUAN = Drip.constant.uaInfo.IS_MEITUAN;
          // 美团https调用knb上传图片闪退
          if (IS_MEITUAN && isProd) {
            // window.location.replace(`http://h5.dianping.com/app/myshow/#/comments/edit/0?projectId=${performanceInfo.performanceId}`)
            Drip.redirect("http://h5.dianping.com/app/myshow/#/comments/edit/0?projectId=".concat(performanceInfo.performanceId), {
              unFormate: true
            });
          } else {
            // 无订单发表评价时，orderId设为0
            // pageTo(`/comments/edit/0?projectId=${performanceInfo.performanceId}`)
            Drip.redirect("/myshow/#/comments/edit/0?projectId=".concat(performanceInfo.performanceId));
          }
        }
      }
    },
    // 回调，提示即将开售时间
    hintToSellEvent: function hintToSellEvent(onSaleTime) {
      var _this4 = this;
      this.toSellToast = true;
      this.toSellText = '本场次于 ' + formatDate(new Date(onSaleTime), 'M月d日 h时m分') + '开售';
      setTimeout(function () {
        _this4.toSellToast = false;
        _this4.toSellText = '';
      }, 3000);
    },
    mo: function mo(e) {
      e.preventDefault();
    },
    // 截流
    throttle: function throttle(fn, gapTime) {
      if (gapTime === null || gapTime === undefined) {
        gapTime = 1500;
      }
      var _lastTime = null;
      return function () {
        var _nowTime = +new Date();
        if (_nowTime - _lastTime > gapTime || !_lastTime) {
          _lastTime = _nowTime;
          fn.apply(this, arguments); // 将this和参数传给原函数
        }
      };
    },

    handleRefreshGrabStatus: function handleRefreshGrabStatus() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var params, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = {
                buyInstructionType: 1
              };
              _context4.next = 3;
              return _this5.getDetailById(_this5.performanceIdByRoute, params);
            case 3:
              _context4.t0 = _context4.sent;
              if (_context4.t0) {
                _context4.next = 6;
                break;
              }
              _context4.t0 = {};
            case 6:
              data = _context4.t0;
              _this5.performanceInfo.needPreInput = data.needPreInput;
              _this5.performanceInfo.prefillCompleted = data.prefillCompleted;
              Store.remove('routeFrom');
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchRecommendList: function fetchRecommendList() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var performanceId, recommandList;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // 获取推荐模块
              performanceId = _this6.performanceIdByRoute;
              recommandList = [];
              _context5.prev = 2;
              if (_this6.needCloseRecommend) {
                _context5.next = 7;
                break;
              }
              _context5.next = 6;
              return _this6.getRecommendsById(performanceId);
            case 6:
              recommandList = _context5.sent;
            case 7:
              if (recommandList.length > 0) {
                recommandList = recommandList.filter(function (x) {
                  return x.performanceId !== +performanceId;
                }).slice(0, 10);
              }
              _context5.next = 13;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](2);
              console.log('error getRecommendsById', _context5.t0);
            case 13:
              _this6.recommandList = recommandList;
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 10]]);
      }))();
    },
    fetchKugouMusic: function fetchKugouMusic() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$_this7$getkugo, kugouMusicList, kugoubaseInfo;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.getkugouMusicListById(_this7.performanceIdByRoute);
            case 2:
              _yield$_this7$getkugo = _context6.sent;
              kugouMusicList = _yield$_this7$getkugo.kugouMusicList;
              kugoubaseInfo = _yield$_this7$getkugo.kugoubaseInfo;
              _this7.musicList = kugouMusicList;
              _this7.kugoubaseInfo = kugoubaseInfo;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    start: function start() {
      var _arguments = arguments,
        _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var noReset, closeWebview, _this8$newNotesList, _this8$newNotesList$f, performanceId, isAtest, _yield$Promise$all, _yield$Promise$all2, resDetail, lionConfig, isLimitNormal, isLimitLayout, _resDetail$data, data, code, performanceInfo, _ref2, promotionDetails, projectGiftVO, preferenceList, supportWenhui, businessBatchList, tapStatus, isCollect, btnText, reaction, btnType, showMoreInfo, TextAndReaction, parseInfo, _parseInfo, pinRule, _parseInfo2, message;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              noReset = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (!noReset) {
                _this8.pageInit = false;
              }

              // 获取是否在美团且来自搜索来判定是否显示返回按钮
              closeWebview = isLLCloseWebview();
              _this8.closeWebview = closeWebview;
              _context7.prev = 4;
              performanceId = _this8.performanceIdByRoute;
              isAtest = true;
              _context7.next = 9;
              return Promise.all([_this8.getDetailById(performanceId, isAtest ? {
                buyInstructionType: 1
              } : undefined), getLionConfig('projectDetailPageConfig')]);
            case 9:
              _yield$Promise$all = _context7.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              resDetail = _yield$Promise$all2[0];
              lionConfig = _yield$Promise$all2[1];
              // 详情页lion 配置
              Object.prototype.toString.call(lionConfig) === '[object Object]' && (_this8.lionData = Object.freeze(lionConfig));
              _this8.kingHonorFlag = resDetail.kingHonorFlag;
              _this8.externalActivity = resDetail.externalActivity;
              _this8.needCloseRecommend = resDetail.needCloseRecommend;
              _this8.straightLineDistance = resDetail.straightLineDistance;
              // 限流相关处理
              isLimitNormal = resDetail.isLimitNormal, isLimitLayout = resDetail.isLimitLayout, _resDetail$data = resDetail.data, data = _resDetail$data === void 0 ? {} : _resDetail$data, code = resDetail.code;
              if (!isLimitNormal) {
                _context7.next = 22;
                break;
              }
              _this8.setPageLimitObject(code, data);
              return _context7.abrupt("return");
            case 22:
              if (!isLimitLayout) {
                _context7.next = 25;
                break;
              }
              _this8.setPageLimitObject(code, data);
              return _context7.abrupt("return");
            case 25:
              _this8.now = _this8.getNowTime(new Date().getTime(), _this8.mistiming);
              _this8.isLogin = _this8.getLoginStatus();
              performanceInfo = resDetail; // 抖音演出小程序不展示折扣优惠信息，避免审核项目被抖音驳回
              if (Drip.UA.IS_DouyinShowMicroApp && performanceInfo && performanceInfo.promotional) {
                performanceInfo.promotional = Object.assign({}, performanceInfo.promotional, {
                  discountList: [],
                  setTicketList: [],
                  promotionDetails: []
                });
              }
              _this8.performanceInfo = performanceInfo;

              // 是否是直播项目
              performanceInfo.isLive = performanceInfo.categoryId === 11;
              performanceInfo.isGameProject = performanceInfo.categoryId === 14;
              _ref2 = performanceInfo.promotional || {}, promotionDetails = _ref2.promotionDetails, projectGiftVO = _ref2.projectGiftVO, preferenceList = _ref2.preferenceList, supportWenhui = _ref2.supportWenhui, businessBatchList = _ref2.businessBatchList;
              performanceInfo.showCoupon = promotionDetails && promotionDetails.length || projectGiftVO || preferenceList && preferenceList.length || supportWenhui || businessBatchList && businessBatchList.length || false;
              _this8.isShowServiceTitleBar = performanceInfo.serviceTitleList && performanceInfo.serviceTitleList.length > 0;
              // 计算基础信息头部tap标志
              tapStatus = _this8.caculateTapStatus(performanceInfo); // 设置收藏状态
              isCollect = _this8.setCollectStatus(); // 设置分享信息
              _this8.caculateShareParam(performanceInfo);
              _this8.isNeedDisplayGoIndex = _this8.getIsNeedDisplayGoIndex();
              _this8.isNeedDisplayGoOrder = _this8.getIsNeedDisplayGoOrder();
              _this8.tapStatus = tapStatus;
              _this8.mPreview = _this8.getMPreview(performanceInfo, _this8.isMSite);
              _this8.saleStatus = _this8.getSaleStatus(performanceInfo);
              _this8.privilegeActivityStatus = performanceInfo.privilegeActivityStatus;
              _this8.isShowCountDownComponent = _this8.getIsShowCountDownComponent(performanceInfo);
              _this8.isShowPreSaleTitle = _this8.getIsShowPreSaleTitle(_this8.saleStatus);
              _this8.saleRemindVO = _this8.getSaleRemindVO(performanceInfo);
              _this8.isNeedSoldOutRegister = _this8.getIsNeedSoldOutRegister(performanceInfo);
              _this8.isSelectSeatProject = _this8.getIsSelectSeatProject(performanceInfo);
              if (_this8.isSelectSeatProject && _this8.$route.query && _this8.$route.query.seat === 'true') {
                setTimeout(function () {
                  _this8.reactionAccordingToShowInfoAndAreaInfo();
                }, 100);
              }
              _this8.isNeedOnSaleRemind = _this8.getIsNeedOnSaleRemind(_this8.saleRemindVO);
              _this8.isShowRemindText = _this8.getIsShowRemindText(_this8.isNeedOnSaleRemind, _this8.saleStatus);
              if ([0, 1, 2, 3, 4, 5, 6, 13, 14, 15, 16, 17].includes(_this8.saleStatus)) {
                // 正常购票流程
                TextAndReaction = _this8.caculateTextAndReaction(_this8.saleStatus, _this8.isSelectSeatProject, _this8.isNeedOnSaleRemind, _this8.saleRemindVO, _this8.mPreview);
                btnText = TextAndReaction.btnText;
                reaction = TextAndReaction.reaction;
                btnType = TextAndReaction.btnType;
                showMoreInfo = TextAndReaction.showMoreInfo;
                if (_this8.isGameProject && btnType === 'lijigoupiao' && (_this8.$route.query || {}).showListModal === 'true') {
                  _this8.showListModal = true;
                }
              }
              _this8.btnText = btnText;
              _this8.reaction = reaction;
              _this8.btnType = btnType;
              _this8.showMoreInfo = showMoreInfo;
              _this8.isNeedRemindWithPriceModal = _this8.getIsNeedRemindWithPriceModal(performanceInfo);
              _this8.remindTicketPriceList = _this8.getRemindTicketPriceList(performanceInfo);
              _this8.activityType = _this8.getActivitiesInfo(performanceInfo);
              // 设置开售时间的倒计时
              _this8.setOnSaleCountDown(_this8.saleStatus, _this8.saleRemindVO);

              // 加载锚点ui功能
              _this8.LoadAnchor();
              // 预约公示相关
              _this8.setReminderPublic(performanceInfo);
              _this8.getReminderPublicNumber(performanceInfo);

              // 是否展示精彩现场
              _this8.isShowWonderFul = performanceInfo.videoList && performanceInfo.videoList.length > 0 || performanceInfo.photoStageList && performanceInfo.photoStageList.length > 0;
              // 演出延期/取消公告模块
              _this8.showDelayNotice = performanceInfo.projectHandleVO && [13, 14, 15, 16, 17].includes(performanceInfo.saleStatus);

              // banner模块
              _this8.showDetailAd = performanceInfo && performanceInfo.projectServing;

              //演出团购
              _this8.getGroupBy(performanceInfo.performanceId);

              // 游戏剧场项目处理逻辑
              if (performanceInfo.categoryId === 14) {
                isAtest = false;
                _this8.showNewNotes = true;
                try {
                  if (performanceInfo.buyInstructionType) {
                    parseInfo = JSON.parse(performanceInfo.ticketNotes);
                    _this8.newNotesList = parseInfo.filter(function (item) {
                      return (item.showInUserTerminal || item.showInUserTerminal === undefined) && item.content;
                    });
                  } else {
                    _parseInfo = JSON.parse(performanceInfo.ticketNotes);
                    if (performanceInfo.saleType === 1) {
                      pinRule = {
                        code: 13,
                        title: '拼场规则',
                        content: "1.1\u4EBA\u8D77\u62FC\uFF0C\u51D1\u6EE1<span style=\"color: #FF9900;\">".concat(performanceInfo.playerMinNumLimit, "</span>\u4EBA\u5373\u62FC\u573A\u6210\u529F\uFF08\u90E8\u5206\u573A\u6B21\u9664\u5916\uFF09\u3002<br />2.\u62FC\u573A\u6210\u529F\u540E\u5176\u4ED6\u73A9\u5BB6\u4ECD\u53EF\u7EE7\u7EED\u52A0\u5165\uFF0C\u6BCF\u573A\u6700\u591A<span style=\"color: #FF9900;\">").concat(performanceInfo.playerMaxNumLimit, "</span>\u4EBA\uFF08\u90E8\u5206\u573A\u6B21\u9664\u5916\uFF09\u3002<br />3.\u5BF9\u5E94\u573A\u6B21\u5F00\u573A<span style=\"color: #FF9900;\">\u524D").concat(performanceInfo.earlyOffSaleMinute, "\u5206\u949F</span>\uFF0C\u672A\u8FBE\u5230\u5F00\u573A\u6700\u4F4E\u4EBA\u6570\uFF0C\u5373\u62FC\u573A\u5931\u8D25\uFF0C\u7CFB\u7EDF\u5C06\u81EA\u52A8\u9000\u6B3E\u3002")
                      };
                      _parseInfo.unshift(pinRule);
                      _this8.newNotesList = _parseInfo;
                    }
                  }
                } catch (err) {
                  _this8.showNewNotes = false;
                  _this8.newNotesList = [];
                }
              }
              _this8.showNewPage = isAtest;
              if (_this8.showNewPage && performanceInfo.buyInstructionType) {
                try {
                  _parseInfo2 = JSON.parse(performanceInfo.ticketNotes);
                  _this8.showNewNotes = Array.isArray(_parseInfo2);
                  _this8.newNotesList = _parseInfo2.filter(function (item) {
                    return (item.showInUserTerminal || item.showInUserTerminal === undefined) && item.content;
                  });
                } catch (e) {
                  _this8.showNewNotes = false;
                  _this8.newNotesList = [];
                }
              }
              _this8.performanceDuration = (_this8$newNotesList = _this8.newNotesList) === null || _this8$newNotesList === void 0 ? void 0 : (_this8$newNotesList$f = _this8$newNotesList.find(function (e) {
                return (e === null || e === void 0 ? void 0 : e.code) === 1;
              })) === null || _this8$newNotesList$f === void 0 ? void 0 : _this8$newNotesList$f.content;
              try {
                if (performanceInfo.billBoardVO) {
                  window.seedAction({
                    bid: 'b_movie_7973vwvx_mv',
                    evt: 'view',
                    performance_id: performanceInfo.performanceId
                  });
                }
              } catch (e) {}
              _this8.performanceInfo.needCloseDetail = isAtest;
              // 设置页面错误状态
              _this8.pageInitErr = false;
              _this8.pageInitErrType = 'noError';
              if (_this8.isShowDetail) {
                // 这个打点的更改待确定
                if (_this8.performanceInfo.brightPointList && _this8.performanceInfo.brightPointList.length > 0) {
                  _this8.lightViewStats();
                }
                if (_this8.isShowWonderFul) {
                  _this8.videoListViewStats();
                }
              }
              _this8.getValidateResult();

              // 关闭页面限流
              _this8.closeLimitPage();
              _context7.next = 87;
              break;
            case 81:
              _context7.prev = 81;
              _context7.t0 = _context7["catch"](4);
              _this8.pageInitErr = true;
              message = _context7.t0.message;
              if (message.indexOf('outdated') !== -1) {
                _this8.pageInitErrType = 'outdated';
              } else {
                // 其余报错展示统一的流控样式
                _this8.setPageLimitObject(undefined, {});
              }
              _this8.$owlReportError('老上单详情页-页面异常', _context7.t0);
            case 87:
              _context7.prev = 87;
              _this8.$loading.close();
              _this8.pageInit = true;
              if (_this8.pageInitErr) {
                _this8.pageErrorhandler(_this8.pageInitErrType);
              }
              if (!Drip.UA.isNative) {
                // web 非native
                _this8.checkSessionAndNaviToCommnonInfo();
              }
              _this8.$nextTick(function () {
                var pageUnMounted = _this8.pageUnMounted;
                if (!pageUnMounted) {
                  // 防内存泄漏
                  setTimeout(function () {
                    _this8.getDetailComponentStatus();
                    _this8.getLightComponentStatus();
                  }, 300);
                }
              });
              return _context7.finish(87);
            case 94:
              _this8.fetchRecommendList();
              _this8.fetchKugouMusic();
            case 96:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[4, 81, 87, 94]]);
      }))();
    },
    getOnlineStauts: function getOnlineStauts() {
      if (!navigator.onLine) {
        throw new Error('network');
      }
    },
    pageErrorhandler: function pageErrorhandler(err) {
      if (err === 'outdated') {
        this.setPrompt({
          show: true,
          text: '返回',
          content: '项目不存在或已下架',
          type: 'outdated'
        });
      }
    },
    refresh: function refresh() {
      this.start();
    },
    // 返回首页
    backToHome: function backToHome() {
      var sellChannel = Drip.constant.appType;
      var isGewaraApp = Drip.constant.uaInfo.IS_GEWARA;
      // 格瓦拉调起回演出首页
      if (isGewaraApp && sellChannel === 8) {
        var homeUrl = "gewara://com.gewara.movie/dramatab";
        KNB.openWebview({
          url: homeUrl
        });
        return;
      } else if (Drip.UA.IS_DouyinShowMicroApp) {
        window.tt.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
        return;
      } else if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
        window.xhs.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
        return;
      } else if (Drip.UA.IS_MAOYAN) {
        Drip.constant.gotoShowHomeTab();
        return;
      } else if (Drip.UA.IS_MAOYAN_BAIDU_APP) {
        window.swan.webView.switchTab({
          url: '/pages/tabshow/index'
        });
        return;
      }
      var isDianpingUrl = /(ping.com)/.test(location.href);
      var url = isDianpingUrl ? "/app/myshow/index.html#/" : "/qqw#/";
      location.href = url;
    },
    getDetailById: function getDetailById(id) {
      var _arguments2 = arguments,
        _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var params, res, code, data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              params = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};
              _context8.prev = 1;
              if (Drip.UA.isNative) {
                params.encryptCertificateString = _this9.encryptCertificateString;
              }
              _context8.next = 5;
              return getDetail(id, params);
            case 5:
              res = _context8.sent;
              code = res.code, data = res.data;
              if (!(code === 200)) {
                _context8.next = 12;
                break;
              }
              _this9.mistiming = _this9.getMis(res.attrMaps.serverTime); // 标记延迟时间
              return _context8.abrupt("return", data);
            case 12:
              if (!(code === 1002)) {
                _context8.next = 16;
                break;
              }
              throw new Error('outdated');
            case 16:
              if (!(code === NO_COUNTTIME_LIMIT_CODE)) {
                _context8.next = 20;
                break;
              }
              return _context8.abrupt("return", {
                code: code,
                isLimitNormal: true,
                data: data || {}
              });
            case 20:
              if (!(code === HAS_COUNTTIME_LIMIT_CODE)) {
                _context8.next = 24;
                break;
              }
              return _context8.abrupt("return", {
                code: code,
                isLimitLayout: true,
                data: data || {}
              });
            case 24:
              return _context8.abrupt("return", {
                code: code,
                isLimitNormal: true,
                data: {}
              });
            case 25:
              _context8.next = 31;
              break;
            case 27:
              _context8.prev = 27;
              _context8.t0 = _context8["catch"](1);
              // 异常上报
              _this9.$owlReportError('老上单详情页-项目详情接口异常', _context8.t0);
              throw _context8.t0;
            case 31:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[1, 27]]);
      }))();
    },
    // TODO 可以优化为在获取详情信息的主接口中添加标志符控制是否需要调用接口获取酷狗音乐模块
    // 获取酷狗音乐模块
    getkugouMusicListById: function getkugouMusicListById(id) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var kugouMusicList, kugoubaseInfo, params, res, code, data, authorName, authorAvatar, kugouSongsTitle;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              kugouMusicList = [];
              kugoubaseInfo = {};
              _context9.prev = 2;
              params = {
                projectId: id
              };
              _context9.next = 6;
              return getkugouMusicList(params);
            case 6:
              res = _context9.sent;
              code = res.code, data = res.data;
              if (code === 200 && data && data.list && Array.isArray(data.list)) {
                // 只显示列表大小为3的情况
                if (data.list && data.list.length >= 3) {
                  kugouMusicList = data.list.slice(0, 3);
                  authorName = data.authorName, authorAvatar = data.authorAvatar, kugouSongsTitle = data.kugouSongsTitle;
                  kugoubaseInfo = {
                    authorName: authorName,
                    authorAvatar: authorAvatar,
                    kugouSongsTitle: kugouSongsTitle
                  };
                }
              }
              _context9.next = 14;
              break;
            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](2);
              kugouMusicList = [];
            case 14:
              return _context9.abrupt("return", {
                kugouMusicList: kugouMusicList,
                kugoubaseInfo: kugoubaseInfo
              });
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[2, 11]]);
      }))();
    },
    getRecommendsById: function getRecommendsById(id) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var res, code, data, paging, attrMaps;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return getRecommends(id);
            case 3:
              res = _context10.sent;
              code = res.code, data = res.data, paging = res.paging, attrMaps = res.attrMaps;
              if (!(code === 200 && data && Array.isArray(data))) {
                _context10.next = 10;
                break;
              }
              _this10.ABtestReport(attrMaps, paging);
              return _context10.abrupt("return", data);
            case 10:
              return _context10.abrupt("return", []);
            case 11:
              _context10.next = 16;
              break;
            case 13:
              _context10.prev = 13;
              _context10.t0 = _context10["catch"](0);
              return _context10.abrupt("return", []);
            case 16:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 13]]);
      }))();
    },
    ABtestReport: function ABtestReport(attrMaps, paging) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var personalizedRec, recStrategy, abtest, type;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(!paging || paging.pageNo != 1)) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return");
            case 2:
              if (attrMaps) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return");
            case 4:
              personalizedRec = attrMaps.personalizedRec, recStrategy = attrMaps.recStrategy;
              abtest = recStrategy === 2 ? 1 : 0;
              type = personalizedRec === 2 ? 1 : 0; // expId, expStrategy, personalizedRec, recStrategy, https://wiki.maoyan.com/pages/viewpage.action?pageId=200888250
              // abtest 标记abtest分组信息，0-未命中实验，1-命中实验
              // type 是否个性化用户，0-非个性化，1-个性化
              window.seedAction({
                bid: 'b_movie_usyyk9ev_mv',
                evt: 'view',
                custom: {
                  abtest: abtest,
                  type: type,
                  custom: {
                    abtest: abtest,
                    type: type
                  }
                }
              });
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    // 刷新优惠券状态
    changeCouponStatus: function changeCouponStatus() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var performanceId, resDetail, performanceInfo;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              performanceId = _this11.performanceIdByRoute;
              _context12.next = 3;
              return _this11.getDetailById(performanceId, _this11.showNewPage ? {
                buyInstructionType: 1
              } : undefined);
            case 3:
              resDetail = _context12.sent;
              performanceInfo = resDetail;
              _this11.performanceInfo.promotional = performanceInfo.promotional;
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    // 检测session,并根据session，login 上一跳页面来确定是否需要进入常用信息页面
    // 仅用于web端
    checkSessionAndNaviToCommnonInfo: function checkSessionAndNaviToCommnonInfo() {
      if (Drip.User.isLogin) {
        // 已经登录
        var isHasBeenLoginPage = sessionStorage.getItem('prefillAndLogin');
        var previousPath = window.previousUrlObject.path;
        // 曾经到过登录页面 且 通过首页，或者重定向的方法进入到此页面
        if (isHasBeenLoginPage === 'yes' && previousPath === '/') {
          this.goToCommonInfo();
        }
      }
      sessionStorage.removeItem('prefillAndLogin'); // 每次必定清空sessionStorage, 无论信息是否被消费
    },

    setCommonInfoSession: function setCommonInfoSession() {
      sessionStorage.setItem('prefillAndLogin', 'yes'); // 产生storage信息
    },

    goToCommonInfo: function goToCommonInfo() {
      var _this12 = this;
      var performanceId = this.performanceId,
        _this$performanceInfo = this.performanceInfo,
        needRealName = _this$performanceInfo.needRealName,
        needFaceCheck = _this$performanceInfo.needFaceCheck;
      var self = this;
      if (Drip.User.isLogin) {
        this.$router.push({
          path: '/common-info',
          query: {
            type: needRealName ? 1 : 2,
            performanceId: performanceId,
            needFaceCheck: needFaceCheck ? 1 : 0 // 项目是否需要人脸认证
          }
        });
      } else {
        try {
          if (Drip.UA.isNative) {
            Drip.login().then(function () {
              _this12.isLogin = true;
              self.goToCommonInfo();
            }).catch(function (err) {
              console.warn(err);
            });
          } else {
            this.setCommonInfoSession();
            Drip.login();
            this.isLogin = true;
          }
        } catch (error) {}
      }
    },
    /* *******M站预览引导相关方法********  */checkUaAndSite: function checkUaAndSite() {
      var isM = Drip.UA.IS_QQWALLET;
      var ua = navigator.userAgent.toLowerCase();
      var isWxWbQQ = false;
      if (ua.match(/MicroMessenger/i)) {
        // 在微信中打开
        isWxWbQQ = true;
      } else if (ua.match(/WeiBo/i)) {
        isWxWbQQ = true;
      } else if (ua.match(/QQ/i)) {
        // 在QQ空间打开
        // isWxWbQQ = true
        isWxWbQQ = false;
      } else if (ua.match(/uc/i)) {
        isWxWbQQ = true;
      }
      this.isMSite = isM;
      this.isWxWbQQ = isWxWbQQ;
      // 判断是否在app中
    },

    checkAndReload: function checkAndReload() {
      this.checkUaAndSite();
      var isMSite = this.isMSite,
        isWxWbQQ = this.isWxWbQQ;
      var osName = Drip.UA.osName;
      var isIos = osName.indexOf('ios') !== -1;
      var href = window.location.href;
      var hasSHareTIme = href.indexOf('shareTime') !== -1;
      if (isMSite && isWxWbQQ && isIos) {
        // ios 端 在wb/wx/qq则刷新url，添加time标记为不同的链接
        if (!hasSHareTIme) {
          var shareTime = new Date().getTime();
          var _window$location = window.location,
            hash = _window$location.hash,
            host = _window$location.host,
            pathname = _window$location.pathname,
            search = _window$location.search,
            protocol = _window$location.protocol;
          var newSearch = search.indexOf('?') !== -1 ? "".concat(search, "&_shareTime=").concat(shareTime) : "?_shareTime=".concat(shareTime);
          var newUrl = "".concat(protocol, "//").concat(host).concat(pathname).concat(newSearch).concat(hash);
          window.location = newUrl;
          return true;
        }
      }
      return false;
    },
    checkMSiteAndCallback: function checkMSiteAndCallback(callback) {
      var self = this;
      return function (args) {
        // 判断当前环境
        // 如果是m站且设置了预览，则弹出引导 qq/wb/wx 引导到普通浏览器 | 普通浏览器引导到app 或小程序
        var cb = callback.bind(self);
        var isMSite = self.isMSite,
          isWxWbQQ = self.isWxWbQQ,
          performanceInfo = self.performanceInfo;
        var preview = performanceInfo.preview;
        if (isMSite && preview) {
          if (isWxWbQQ) {
            // 引导倒你普通浏览器
            self.toggleMTutorial();
          } else {
            // 展示m站跳转购票引导 引导倒app或微信小程序
            self.toggleMJumpModal();
            window.seedAction({
              cid: 'c_c21utqjf',
              bid: 'b_movie_2j3150vd_mc',
              evt: 'click',
              needTag: true
            });
          }
          return;
        }
        cb(args);
      };
    },
    MSitejumpOrShowCode: function MSitejumpOrShowCode(event) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var type, _yield$getQRCode, code, data, performanceId;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              type = event.type;
              if (!(type === 'weixin')) {
                _context13.next = 14;
                break;
              }
              _context13.next = 4;
              return getQRCode(824, 'pages/show/detail/index', _this13.performanceId, 'msite');
            case 4:
              _yield$getQRCode = _context13.sent;
              code = _yield$getQRCode.code;
              data = _yield$getQRCode.data;
              if (!LIMIT_CODE.includes(code)) {
                _context13.next = 10;
                break;
              }
              _this13.setModalLimitObject(code, data, 'qrcode');
              return _context13.abrupt("return");
            case 10:
              if (code === 200) {
                _this13.mQRcode = data;
              } else {
                _this13.mQRcode = '';
                _this13.$toast('二维码生成失败，请到微信-钱包-猫眼小程序中购买');
              }
              if (_this13.mQRcode !== '') {
                _this13.toggleMCode();
                window.seedAction({
                  cid: 'c_c21utqjf',
                  bid: 'b_movie_1gn1rtkb_mc',
                  evt: 'click',
                  needTag: true
                });
              }
              _context13.next = 19;
              break;
            case 14:
              performanceId = _this13.performanceId;
              if (type === 'gewara') {
                if (isProd) {
                  location.href = "https://evt.dianping.com/synthesislink/17649.html?dramaid=".concat(performanceId);
                } else {
                  location.href = "https://evt.dianping.com/synthesislink/1318206.html?dramaid=".concat(performanceId, " ");
                }
              }
              if (type === 'meituan') {
                try {
                  window.seedAction({
                    cid: 'c_c21utqjf',
                    bid: 'b_movie_7lot92rg_mc',
                    evt: 'click',
                    needTag: true
                  });
                } catch (error) {}
                openApp.openWeb({
                  appType: 'meituan',
                  pId: performanceId
                });
              }
              if (type === 'dianping') {
                try {
                  window.seedAction({
                    cid: 'c_c21utqjf',
                    bid: 'b_movie_ep2qpxty_mc',
                    evt: 'click',
                    needTag: true
                  });
                } catch (error) {}
                openApp.openWeb({
                  appType: 'dianping',
                  pId: performanceId
                });
              }
              if (type === 'maoyan') {
                try {
                  window.seedAction({
                    cid: 'c_c21utqjf',
                    bid: 'b_movie_0nciirrt_mc',
                    evt: 'click',
                    needTag: true
                  });
                } catch (error) {}
                openApp.openWeb({
                  appType: 'maoyan',
                  pId: performanceId
                });
              }
            case 19:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    // 引导m站到普通浏览器弹窗
    toggleMTutorial: function toggleMTutorial() {
      this.showMTutorial = !this.showMTutorial;
    },
    // 引导m站跳转弹窗
    toggleMJumpModal: function toggleMJumpModal() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _yield$getMsitePlafor, _yield$getMsitePlafor2, code, _yield$getMsitePlafor3, data, platforms, hasMiniapp;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (_this14.showMJumpModal) {
                _context14.next = 13;
                break;
              }
              _context14.next = 3;
              return getMsitePlaforms(_this14.performanceId);
            case 3:
              _yield$getMsitePlafor = _context14.sent;
              _yield$getMsitePlafor2 = _yield$getMsitePlafor.code;
              code = _yield$getMsitePlafor2 === void 0 ? null : _yield$getMsitePlafor2;
              _yield$getMsitePlafor3 = _yield$getMsitePlafor.data;
              data = _yield$getMsitePlafor3 === void 0 ? null : _yield$getMsitePlafor3;
              if (!LIMIT_CODE.includes(code)) {
                _context14.next = 11;
                break;
              }
              _this14.setModalLimitObject(code, data, 'JumpModal');
              return _context14.abrupt("return");
            case 11:
              _this14.closeLimitModal();
              if (code === 200) {
                platforms = data.filter(function (code) {
                  return code === 1 || code === 2 || code === 5 || code === 8;
                });
                hasMiniapp = data.includes(7);
                _this14.MPlatforms = {
                  platforms: platforms,
                  miniapp: hasMiniapp
                };
              } else {
                _this14.MPlatforms = {
                  platforms: [],
                  miniapp: false
                };
              }
            case 13:
              _this14.showMJumpModal = !_this14.showMJumpModal;
            case 14:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    toggleMCode: function toggleMCode() {
      this.showMCode = !this.showMCode;
    },
    getDetailComponentStatus: function getDetailComponentStatus() {
      var detailComponent = document.getElementById('detail-content');
      if (detailComponent) {
        var clientHeight = detailComponent.clientHeight;
        if (clientHeight > 400) {
          this.detailComponentShowMask = true;
        }
      }
    },
    getLightComponentStatus: function getLightComponentStatus() {
      var lightComponent = document.getElementById('light-content');
      if (lightComponent) {
        var clientHeight = lightComponent.clientHeight;
        if (clientHeight > 900) {
          this.lightComponentShowMask = true;
        }
      }
    },
    getMis: function getMis(serverTime) {
      // 获取延时
      var ms = new Date() - serverTime;
      return ms;
    },
    getSaleStatus: function getSaleStatus(performanceInfo) {
      /**
       * 0 缺省值
       * 1 即将开售
       * 2 预售
       * 3 售票中
       * 4 售罄 预售
       * 5 售罄 售票中
       * 6 已结束
       *
       * 7 先付开始前
       * 8 先付进行中
       * 9 先付结束 先抢购时间待定
       * 10 先抢时间确定，先抢开始前
       * 11 先抢进行中
       * 12 先抢票结束
       * 13 项目延期
       * 14 项目取消
       * 15 部分延期
       * 16 部分取消
       * 17 部分延期,部分取消
       */
      return performanceInfo.saleStatus;
    },
    getIsShowCountDownComponent: function getIsShowCountDownComponent(performanceInfo) {
      var saleRemindVO = performanceInfo.saleRemindVO;
      var need;
      if (!saleRemindVO) {
        need = false;
      } else {
        need = saleRemindVO.needCountDown;
      }
      return need;
    },
    getIsShowPreSaleTitle: function getIsShowPreSaleTitle(saleStatus) {
      return saleStatus === 2 || saleStatus === 4;
    },
    getIsShowRemindText: function getIsShowRemindText(isNeedOnSaleRemind, saleStatus) {
      return saleStatus === 1 && isNeedOnSaleRemind;
    },
    getSaleRemindVO: function getSaleRemindVO(performanceInfo) {
      return performanceInfo.saleRemindVO;
    },
    getIsSelectSeatProject: function getIsSelectSeatProject(performanceInfo) {
      // 是否选座
      // 1 选座 0 非选座 2 既有选座, 也有非选座(已经被取消))
      return performanceInfo.seatType;
    },
    getIsNeedOnSaleRemind: function getIsNeedOnSaleRemind(saleRemindVO) {
      // 是否开售提醒
      // 服务降级导致信息缺失
      if (!saleRemindVO) {
        var errMsg = 'saleRemindVO为空';
        var errObj = new Error(errMsg); // 记录堆栈信息

        this.$owlReportError('新项目详情页-项目详情接口异常', errObj);
        return 0;
      }
      return saleRemindVO.needRemind ? 1 : 0;
    },
    getIsNeedSoldOutRegister: function getIsNeedSoldOutRegister(performanceInfo) {
      // 1 是缺货登记项目  0 非缺货登记项目
      return performanceInfo.stockOutRegister ? 1 : 0;
    },
    getActivitiesInfo: function getActivitiesInfo(performanceInfo) {
      // 获取外部活动的信息
      var activityType = performanceInfo.activityType;
      return activityType;
    },
    getIsNeedDisplayGoIndex: function getIsNeedDisplayGoIndex() {
      //salesWay
      if (Drip.UA.isNative || Drip.UA.IS_TENGJING || Drip.UA.IS_MAIDANBA) {
        return false;
      }
      return true;
    },
    getIsNeedDisplayGoOrder: function getIsNeedDisplayGoOrder() {
      //salesWay
      if (Drip.UA.isNative || Drip.UA.IS_TENGJING) {
        return false;
      }
      return true;
    },
    getMPreview: function getMPreview(performanceInfo, isMSite) {
      // 判断是否m站且预览功能开启的情况
      return performanceInfo.preview && isMSite;
    },
    caculateTextAndReaction: function caculateTextAndReaction(saleStatus, isSelectSeatProject, isNeedOnSaleRemind, beforeSaleStatus, mPreview) {
      if (saleStatus === 999 || isSelectSeatProject === 999 || isNeedOnSaleRemind === 999 || saleStatus === 0) {
        // 数据未完成初始化时要直接返回，此方法应该在完成拉取页面数据和预处理时被调用
        return {
          btnText: 'unknown',
          reaction: 'unknown',
          btnType: 'unknown'
        };
      }
      var btnText;
      var reaction;
      if (((this.lionData || {}).allSoldOutProjectIds || []).includes(this.performanceId)) {
        // 全部售罄 注意这里是通过 线上lion 配置 [ http://lion.inf.test.sankuai.com/config/configList.vhtml?menu=project&projectName=maoyan-show-m-web  ( maoyan-show-m-web.frontEnd.config.projectDetailPageConfig ) ]
        btnText = '全部售罄';
        reaction = 'noop';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'end'
        };
      }

      // 特殊处理m站预览
      // m 站预览 且 处于即将开售阶段，不管是否设置开售提醒，都只显示马上看演出
      if (saleStatus === 1 && mPreview) {
        btnText = '马上看演出';
        reaction = 'noop';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'mashangkanyanchu'
        };
      }
      // 票档开售提醒 已开启
      if (saleStatus === 1 && isNeedOnSaleRemind === 1 && beforeSaleStatus.needPreSelect === 1) {
        btnText = beforeSaleStatus && beforeSaleStatus.register ? '已 预 约' : '预约抢票 快人一步';
        reaction = 'preTicket';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'yuyuepiaodang'
        };
      }
      // 1.即将开售阶段
      // 即将开售阶段 未设置开售提醒 点击无跳转 开售后是售票中状态
      if (saleStatus === 1 && isNeedOnSaleRemind === 0 && beforeSaleStatus.onSaleStatus === 1) {
        btnText = '即将开售';
        reaction = 'toast';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'jijiangkaishou'
        };
      }
      // 即将开售阶段 未设置开售提醒 点击无跳转 开售后是预售状态
      if (saleStatus === 1 && isNeedOnSaleRemind === 0 && beforeSaleStatus.onSaleStatus === 2) {
        btnText = '即将开抢';
        reaction = 'toast';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'jijiangyushou'
        };
      }
      // 即将开售阶段 设置了开售提醒 弹出开售提醒弹窗，去填写手机号
      if (saleStatus === 1 && isNeedOnSaleRemind === 1) {
        btnText = beforeSaleStatus && beforeSaleStatus.register ? '已 预 约' : '预约抢票';
        reaction = 'showRemindModal';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'tixingwo'
        };
      }
      // 2.预售阶段
      // 预售阶段 非选座 不管有无库存 不管是否设置了缺货登记 跳至票品选择页，确认选票
      if ((saleStatus === BUTTONSTATUS.PRESALE || saleStatus === BUTTONSTATUS.SELLOUTPRE) && !isSelectSeatProject) {
        // 【优惠】存在有折扣/套票/优惠券则文案为特惠预订 ，无则文案为立即预订
        btnText = this.performanceInfo.showCoupon ? '特惠预订' : '立即预订';
        reaction = 'jumpToSelectTicketsPage';
        // 售罄
        if (saleStatus === BUTTONSTATUS.SELLOUTPRE) {
          btnText = this.saleOutShowText();
        }
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'lijiyuding'
        };
      }
      var allowHKDemo = this.performanceInfo.allowHKDemo;
      // hk项目
      if (allowHKDemo && [2, 3, 4].includes(saleStatus)) {
        this.performanceInfo.modelStyle = 4;
        btnText = '立即购票';
        reaction = 'jumpToSelectTicketsPage';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'lijigoupiao'
        };
      }
      // 预售阶段 新选座/老选座 不管票有没有库存、没库存时有没有缺货登记，都出“选座购票” ==> 只要是个选座项目就出选座购票
      // 此处点击交互需根据是新选座还是老选座来确定
      // (最新全切新选座)
      if ((saleStatus === BUTTONSTATUS.PRESALE || saleStatus === BUTTONSTATUS.SELLOUTPRE) && !!isSelectSeatProject) {
        // 【优惠】存在有折扣/套票/优惠券则文案为特惠选座 ，无则文案为选座购票
        btnText = this.performanceInfo.showCoupon ? '特惠选座' : '选座购票';
        reaction = 'reactionAccordingToShowInfoAndAreaInfo';
        // 售罄
        if (saleStatus === BUTTONSTATUS.SELLOUTPRE) {
          btnText = this.saleOutShowText();
        }
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'xuanzuogoupiao'
        };
      }

      // 3.售票中阶段 （现时，售票中阶段的按钮展示和交互逻辑和预售阶段是一致的，为了应对日后业务需求的变化，故在此进行罗列）
      // 售票中阶段 非选座 不管有无库存 不管是否设置了缺货登记 跳至票品选择页，确认选票
      if ((saleStatus === BUTTONSTATUS.ONSALE || saleStatus === BUTTONSTATUS.SELLOUT) && !isSelectSeatProject) {
        // 【优惠】存在有折扣/套票/优惠券则文案为特惠购票 ，无则文案为立即购票
        btnText = this.performanceInfo.showCoupon ? '特惠购票' : '立即购票';

        // 沉浸式剧场项目，特殊展示文案
        if (this.performanceInfo.categoryId === 14) {
          var priceList = this.performanceInfo.priceList;
          var miniTicketPrice = null;
          if (priceList && priceList[0]) {
            btnText = "".concat(priceList[0], "\u5143\u8D77\uFF0C\u7ACB\u5373\u8D2D\u7968");
            miniTicketPrice = +priceList[0];
          }
          var _ref3 = this.performanceInfo.promotional || {},
            discountList = _ref3.discountList;
          var minSellPrice = Math.min.apply(Math, _toConsumableArray((discountList || []).map(function (a) {
            return a.sellPrice;
          })));
          if (miniTicketPrice !== null && Number.isFinite(minSellPrice) && minSellPrice < miniTicketPrice) {
            btnText = "".concat(minSellPrice, "\u5143\u8D77\uFF0C\u7279\u60E0\u8D2D\u7968");
          }
        }

        // 售罄
        if (saleStatus === BUTTONSTATUS.SELLOUT) {
          btnText = this.saleOutShowText();
        }
        reaction = 'jumpToSelectTicketsPage';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'lijigoupiao'
        };
      }
      // 售票中阶段 新选座/老选座 不管票有没有库存、没库存时有没有缺货登记，都出“选座购票” ==> 只要是个选座项目就出选座购票
      // 此处点击交互需根据是新选座还是老选座来确定
      // (最新全切新选座)
      if ((saleStatus === BUTTONSTATUS.ONSALE || saleStatus === BUTTONSTATUS.SELLOUT) && !!isSelectSeatProject) {
        // 【优惠】存在有折扣/套票/优惠券则文案为特惠选座 ，无则文案为选座购票
        btnText = this.performanceInfo.showCoupon ? '特惠选座' : '选座购票';
        reaction = 'reactionAccordingToShowInfoAndAreaInfo';
        // 售罄
        if (saleStatus === BUTTONSTATUS.SELLOUT) {
          btnText = this.saleOutShowText();
        }
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'xuanzuogoupiao'
        };
      }
      // 4. 项目已经借宿
      if (saleStatus === 6) {
        btnText = '已结束';
        reaction = 'noop';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'end'
        };
      }
      // 5. 项目延期
      if (saleStatus === 13) {
        btnText = '演出延期';
        reaction = 'showProjectDelayPopup';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'yanchuyanqi',
          showMoreInfo: true
        };
      }
      // 6. 项目取消
      if (saleStatus === 14) {
        btnText = '演出取消';
        reaction = 'noop';
        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'end'
        };
      }
      // 7. 部分延期 部分取消 部分延期/取消
      if ([15, 16, 17].includes(saleStatus)) {
        var btnName = {
          15: '演出部分延期',
          16: '演出部分取消',
          17: '演出部分取消/延期'
        };
        btnText = btnName[saleStatus];
        if (!isSelectSeatProject) {
          reaction = 'jumpToSelectTicketsPage'; // 非选座项目直接进入票品选择页
        } else {
          reaction = 'reactionAccordingToShowInfoAndAreaInfo'; // 选座项目
        }

        return {
          btnText: btnText,
          reaction: reaction,
          btnType: 'bufenyanqiquxiao',
          showMoreInfo: true
        };
      }
      // 以上情况都没有匹配
      return {
        btnText: '',
        reaction: 'noop',
        btnType: 'no-captable'
      };
    },
    saleOutShowText: function saleOutShowText() {
      return this.isNeedSoldOutRegister ? selloutEnums.REGISTERED : selloutEnums.UNREGISTERED;
    },
    setOnSaleCountDown: function setOnSaleCountDown(saleStatus, saleRemindVO) {
      var _this15 = this;
      // 清除之前的定时器
      this.clearOnSaleInterval();
      if (!this.onSaleTimers) {
        var onSaleTime = saleRemindVO.onSaleTime;
        if (saleStatus === 1 && !!onSaleTime) {
          // 即将开售阶段而且有开售时间才需要设置定时器
          var self = this;
          var mistiming = self.mistiming;
          var step = function step() {
            var current = new Date().getTime();
            var now = self.getNowTime(current, mistiming);
            if (now > onSaleTime) {
              // 倒计时结束
              _this15.clearOnSaleInterval();
              _this15.changeToOnSale(); // 转换状态
              _this15.countDownEnd = true; // 设置状态
            } else {
              _this15.now = now;
              _this15.onSaleTimers = window.requestAnimationFrame(step);
            }
          };
          this.onSaleTimers = window.requestAnimationFrame(step);
        }
      }
    },
    clearOnSaleInterval: function clearOnSaleInterval() {
      if (this.onSaleTimers) {
        window.cancelAnimationFrame(this.onSaleTimers);
        this.onSaleTimers = null;
      }
    },
    changeToOnSale: function changeToOnSale() {
      // 切换到开售状态
      var onSaleStatus = this.saleRemindVO.onSaleStatus;
      var nextSaleStatus = onSaleStatus === 2 ? 2 : 3;
      var _this$caculateTextAnd = this.caculateTextAndReaction(nextSaleStatus, this.isSelectSeatProject, this.isNeedOnSaleRemind, this.saleRemindVO, this.mPreview),
        btnText = _this$caculateTextAnd.btnText,
        reaction = _this$caculateTextAnd.reaction,
        btnType = _this$caculateTextAnd.btnType,
        showMoreInfo = _this$caculateTextAnd.showMoreInfo;
      this.btnText = btnText;
      this.reaction = reaction;
      this.btnType = btnType;
      this.saleStatus = nextSaleStatus;
      this.showMoreInfo = showMoreInfo;
      this.isShowPreSaleTitle = this.getIsShowPreSaleTitle(nextSaleStatus);
    },
    getNowTime: function getNowTime(current, mistiming) {
      // 获取准确的服务器当前时间
      return current - mistiming;
    },
    getLoginStatus: function getLoginStatus() {
      return Drip.User.isLogin;
    },
    // 手动触发login时，请调用此方法, islogin 的 watch 方法会在自动login时被调用，请却别两者
    handyLoginCallback: function handyLoginCallback() {
      this.setCollectStatus(); // 刷新收藏状态
    },

    checkLoginReaction: function checkLoginReaction(cb) {
      return function loginAndCall() {
        var _this16 = this;
        var callback = cb.bind(this);
        var isNeedLogin = true;
        var btnType = this.btnType;
        if (btnType === 'jijiangkaishou' || btnType === 'jijiangyushou') {
          // 即将开售 || 即将开售不需要login
          isNeedLogin = false;
        }
        if (!Drip.User.isLogin && isNeedLogin) {
          Drip.login().then( /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(res) {
              return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    if (!Drip.User.isLogin) {
                      _context15.next = 4;
                      break;
                    }
                    _context15.next = 3;
                    return callback();
                  case 3:
                    _this16.handyLoginCallback();
                  case 4:
                  case "end":
                    return _context15.stop();
                }
              }, _callee15);
            }));
            return function (_x) {
              return _ref4.apply(this, arguments);
            };
          }()).catch(function (err) {
            console.warn(err);
          });
        } else {
          callback();
        }
      };
    },
    checkSellChannelAndNavigateToQRCodePage: function checkSellChannelAndNavigateToQRCodePage(cb) {
      // 检测当前sellchanel，判定是否需要跳转到二维码页面，引导到小程序
      return function navigateToQRCodePage() {
        var sellChannel = Drip.constant.appType;
        if (sellChannel === 6) {
          var performanceId = this.performanceInfo.performanceId;
          window.location.href = "https://m.maoyan.com/jumpwxapp?path=".concat(encodeURIComponent("/pages/show/detail/index?id=".concat(performanceId)));
        } else {
          var callback = cb.bind(this);
          callback();
        }
      };
    },
    buttonReaction: function buttonReaction() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var closed, reaction, nextDestination, _this17$performanceIn, performanceId, modelStyle, now, _ref5, onSaleTime, query, checkResult;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              closed = true;
              _context16.prev = 1;
              reaction = _this17.reaction;
              if (!(reaction === 'unknown')) {
                _context16.next = 5;
                break;
              }
              return _context16.abrupt("return");
            case 5:
              if (!(reaction === 'noop')) {
                _context16.next = 7;
                break;
              }
              return _context16.abrupt("return");
            case 7:
              if (!(reaction === 'toast')) {
                _context16.next = 11;
                break;
              }
              // 弹出toast提示
              if (_this17.btnType === 'jijiangkaishou') {
                _this17.$toast('即将开售，请耐心等待');
              }
              if (_this17.btnType === 'jijiangyushou') {
                _this17.$toast('即将开抢，请耐心等待');
              }
              return _context16.abrupt("return");
            case 11:
              if (!(reaction === 'showRemindModal')) {
                _context16.next = 17;
                break;
              }
              if (!(_this17.saleRemindVO && _this17.saleRemindVO.register)) {
                _context16.next = 15;
                break;
              }
              // notifyCalendar({title: this.performanceInfo.name, start: this.performanceInfo.saleRemindVO.onSaleTime})
              _this17.$toast('已预约，请耐心等候');
              return _context16.abrupt("return");
            case 15:
              _this17.showRemindModal();
              return _context16.abrupt("return");
            case 17:
              if (!(reaction === 'showProjectDelayPopup')) {
                _context16.next = 20;
                break;
              }
              // 展示项目延期提示框收集想看意愿，不做跳转
              _this17.showProjectDelayPopup();
              return _context16.abrupt("return");
            case 20:
              if (!(reaction === 'jumpToSelectTicketsPage')) {
                _context16.next = 27;
                break;
              }
              // 跳转到票品选择
              if (_this17.btnType === 'lijiyuding') {
                // 立即预订打点
                _this17.bookTicketsNowStatus();
              }
              if (_this17.btnType === 'lijigoupiao') {
                // 立即预订打点
                _this17.buyTicketsNowStats();
              }

              // 普通购票 跳至普通票档页
              if (!_this17.isGameProject) {
                _context16.next = 26;
                break;
              }
              _this17.showListModal = true;
              return _context16.abrupt("return");
            case 26:
              nextDestination = _this17.jumpToSelectTicketsPage();
            case 27:
              if (!(reaction === 'preTicket')) {
                _context16.next = 37;
                break;
              }
              _this17.onSaleRemindMeClick();
              _this17$performanceIn = _this17.performanceInfo, performanceId = _this17$performanceIn.performanceId, modelStyle = _this17$performanceIn.modelStyle;
              now = _this17.getNowTime(new Date().getTime(), _this17.mistiming);
              _ref5 = _this17.saleRemindVO || {}, onSaleTime = _ref5.onSaleTime;
              if (!(onSaleTime && onSaleTime - now < 4000)) {
                _context16.next = 35;
                break;
              }
              // 开售前3s内禁止进入预选票档页面
              _this17.$toast('即将开售，请关注开售时间');
              return _context16.abrupt("return");
            case 35:
              query = "id=".concat(performanceId, "&modelStyle=").concat(modelStyle, "&closekey=preTicket");
              nextDestination = _this17.urlPacking("/pre-ticket?".concat(query));
            case 37:
              if (!_this17.showLimitingModal) {
                // 没有出现限流，才出现loading
                _this17.$loading();
                closed = false;
                setTimeout(function () {
                  if (!closed) {
                    closed = true;
                    _this17.$loading.close();
                  }
                }, 3000);
              }

              // 特权购活动 跳转至特权购流程
              if (!(_this17.activityType === 1)) {
                _context16.next = 48;
                break;
              }
              _context16.next = 41;
              return _this17.jumpToPrivilege();
            case 41:
              nextDestination = _context16.sent;
              if (nextDestination) {
                _context16.next = 44;
                break;
              }
              return _context16.abrupt("return");
            case 44:
              if (!(typeof nextDestination === 'string')) {
                _context16.next = 48;
                break;
              }
              _context16.next = 47;
              return _this17.navigateToNextPage(nextDestination);
            case 47:
              return _context16.abrupt("return");
            case 48:
              if (!(_this17.kingHonorFlag && _this17.externalActivity)) {
                _context16.next = 54;
                break;
              }
              _context16.next = 51;
              return _this17.LOLCheck(_this17.performanceInfo.performanceId);
            case 51:
              checkResult = _context16.sent;
              if (checkResult) {
                _context16.next = 54;
                break;
              }
              return _context16.abrupt("return", undefined);
            case 54:
              if (!(reaction === 'reactionAccordingToShowInfoAndAreaInfo')) {
                _context16.next = 59;
                break;
              }
              _context16.next = 57;
              return _this17.reactionAccordingToShowInfoAndAreaInfo();
            case 57:
              nextDestination = _context16.sent;
              // 选座购票打点
              _this17.selectSeatBuyTickets();
            case 59:
              _context16.next = 61;
              return _this17.navigateToNextPage(nextDestination);
            case 61:
              _context16.next = 67;
              break;
            case 63:
              _context16.prev = 63;
              _context16.t0 = _context16["catch"](1);
              _context16.t0.message = "\u8D2D\u7968\u6838\u5FC3\u6D41\u7A0B\uFF1A".concat(_context16.t0.message);
              _this17.$owlReportError('老上单详情页-购票核心流程异常', _context16.t0);
            case 67:
              _context16.prev = 67;
              if (!closed) {
                closed = true;
                _this17.$loading.close();
              }
              return _context16.finish(67);
            case 70:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[1, 63, 67, 70]]);
      }))();
    },
    /** 演出延期的相关逻辑 */showProjectDelayPopup: function showProjectDelayPopup() {
      this.isShowDelayPopup = true;
    },
    closeDelayPopup: function closeDelayPopup() {
      this.isShowDelayPopup = false;
      this.onSessionListClose();
    },
    // 添加收藏
    addProjectWanted: function addProjectWanted() {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var text, res, _res, code, data, msg, textUA, firstText;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this18.onSessionListClose();
              if (!_this18.isCollect) {
                _context17.next = 5;
                break;
              }
              _this18.$toast('你已经收藏过了~');
              _context17.next = 12;
              break;
            case 5:
              text = '收藏成功！';
              res = {};
              _context17.next = 9;
              return addCollect(_this18.performanceId);
            case 9:
              res = _context17.sent;
              _res = res, code = _res.code, data = _res.data, msg = _res.msg;
              if (code === 200 && data) {
                _this18.isCollect = !_this18.isCollect;
                textUA = Drip.UA.IS_MAOYAN ? '可在“我的—演出”中查看' : '可在“我的—收藏”中查看';
                firstText = data.everFavor === false ? textUA : ''; // 首次收藏增加提示
                _this18.$toast(text + firstText);
              } else if (LIMIT_CODE.includes(code) || code === 1103) {
                _this18.$toast('您已经标记想看了～');
              } else {
                _this18.$toast(msg || _this18.$ERROR_TEXT);
              }
            case 12:
              _this18.isShowDelayPopup = false;
            case 13:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    remindRequest: function remindRequest() {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var remindNumber, performanceId, isNeedRemindWithPriceModal, remindTicketPriceList, parmas, selectedPrice;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              remindNumber = _this19.remindNumber, performanceId = _this19.performanceId, isNeedRemindWithPriceModal = _this19.isNeedRemindWithPriceModal, remindTicketPriceList = _this19.remindTicketPriceList;
              parmas = {
                performanceId: performanceId
              };
              if (isNeedRemindWithPriceModal && remindTicketPriceList.length > 0) {
                // 有票档
                selectedPrice = remindTicketPriceList.filter(function (item) {
                  return !!item.selected;
                });
                selectedPrice = selectedPrice.map(function (item) {
                  var newItem = Object.assign({}, item);
                  delete newItem.selected;
                  return newItem;
                });
                parmas.ticketPriceList = selectedPrice;
                parmas.phoneNumber = remindNumber;
              }
              _context18.prev = 3;
              _context18.next = 6;
              return submitRemind(parmas);
            case 6:
              return _context18.abrupt("return", _context18.sent);
            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18["catch"](3);
              // 发生错误，错误处理
              _this19.$toast(_this19.$ERROR_TEXT);
              _this19.$owlReportError('老上单详情页-提交开售提醒接口异常', _context18.t0);
            case 13:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[3, 9]]);
      }))();
    },
    andriodCancle: function andriodCancle() {
      var _this20 = this;
      this.calendarAndriodVis = false;
      setTimeout(function () {
        _this20.isShowRemindModal = true;
      }, 500);
    },
    andriodConfirm: function andriodConfirm() {
      var _this21 = this;
      this.calendarAndriodVis = false;
      setTimeout(function () {
        Store.set('setCalendar', true);
        notifyCalendar({
          title: _this21.performanceInfo.name,
          start: _this21.saleRemindVO.onSaleTime
        });
      }, 500);
    },
    /** 开售提醒逻辑 */showRemindModal: function showRemindModal() {
      var _this22 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var res, code, data, msg, _res$attrMaps$mobile, mobile, start, title, result;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this22.onSaleRemindMeClick();
              if (_this22.isNeedRemindWithPriceModal) {
                _context19.next = 36;
                break;
              }
              _context19.prev = 2;
              if (Drip.User.isLogin) {
                _context19.next = 6;
                break;
              }
              _context19.next = 6;
              return Drip.login();
            case 6:
              _context19.next = 8;
              return _this22.remindRequest();
            case 8:
              res = _context19.sent;
              code = res.code, data = res.data, msg = res.msg, _res$attrMaps$mobile = res.attrMaps.mobile, mobile = _res$attrMaps$mobile === void 0 ? _this22.numberValue : _res$attrMaps$mobile;
              if (!(code === 200 && data)) {
                _context19.next = 27;
                break;
              }
              _this22.bindMobile = mobile;
              _this22.remindeSource = data;
              start = _this22.saleRemindVO.onSaleTime;
              title = _this22.performanceInfo.name;
              if (!(Drip.UA.isNative && (Drip.UA.IS_MEITUAN || Drip.UA.IS_MAOYAN || Drip.UA.IS_DIANPING) && start)) {
                _context19.next = 24;
                break;
              }
              if (Drip.UA.osName === 'android') {
                // 安卓确认弹窗
                _this22.calendarAndriodVis = true;
              }
              if (!(Drip.UA.osName === 'ios')) {
                _context19.next = 22;
                break;
              }
              _context19.next = 20;
              return notifyCalendar({
                title: title,
                start: start
              });
            case 20:
              result = _context19.sent;
              if (result) {
                // 新日历弹窗 => todo
                _this22.calendarSuccessVis = true;
                _this22.remindRes = res;
              } else {
                _this22.isShowRemindModal = true;
              }
            case 22:
              _context19.next = 25;
              break;
            case 24:
              _this22.isShowRemindModal = true;
            case 25:
              _context19.next = 28;
              break;
            case 27:
              _this22.$toast(msg);
            case 28:
              _context19.next = 34;
              break;
            case 30:
              _context19.prev = 30;
              _context19.t0 = _context19["catch"](2);
              _this22.$toast('小喵没记住手机号，请再试一下');
              _this22.$owlReportError('老上单详情页-提交开售提醒接口异常', _context19.t0);
            case 34:
              _context19.next = 37;
              break;
            case 36:
              _this22.isShowRemindModal = true;
            case 37:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[2, 30]]);
      }))();
    },
    // 判断开售提醒是否带有票档
    getIsNeedRemindWithPriceModal: function getIsNeedRemindWithPriceModal(performanceInfo) {
      // return true
      var isNeedRemindWithPriceModal = performanceInfo.needRemindPrice;
      return isNeedRemindWithPriceModal;
    },
    // 初始化开售提醒票档的状态
    getRemindTicketPriceList: function getRemindTicketPriceList(performanceInfo) {
      // 初始化票档中的选中状态，默认为false
      var remindTicketPriceList = performanceInfo.ticketPriceList || [];
      remindTicketPriceList = remindTicketPriceList.map(function (item) {
        item.selected = false;
        return item;
      });
      return remindTicketPriceList;
    },
    remindModalInputChange: function remindModalInputChange(value) {
      this.remindNumber = value;
    },
    priceTagSelected: function priceTagSelected(id) {
      // 票档被选中，进行返现操作
      var remindTicketPriceList = this.remindTicketPriceList;
      var index = remindTicketPriceList.findIndex(function (element) {
        return element.ticketPriceId === id;
      });
      remindTicketPriceList[index].selected = !remindTicketPriceList[index].selected; // 反向选择操作
      this.remindTicketPriceList = _toConsumableArray(remindTicketPriceList);
    },
    hideRemindModal: function hideRemindModal() {
      this.isShowRemindModal = false;
      this.remindNumber = ''; // 复位
      var remindTicketPriceList = this.remindTicketPriceList,
        isNeedRemindWithPriceModal = this.isNeedRemindWithPriceModal;
      if (isNeedRemindWithPriceModal) {
        var newRemindTicketPriceList = remindTicketPriceList.map(function (element) {
          element.selected = false;
          return element;
        });
        this.remindTicketPriceList = _toConsumableArray(newRemindTicketPriceList); // 还原被选中票档
      }
    },

    remindModalSubmit: function remindModalSubmit(res) {
      var _this23 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _ref6, code, data, msg, _ref6$attrMaps$mobile, mobile, isNeedRemindWithPriceModal;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _ref6 = res || {
                attrMaps: {}
              }, code = _ref6.code, data = _ref6.data, msg = _ref6.msg, _ref6$attrMaps$mobile = _ref6.attrMaps.mobile, mobile = _ref6$attrMaps$mobile === void 0 ? _this23.remindNumber : _ref6$attrMaps$mobile;
              isNeedRemindWithPriceModal = _this23.isNeedRemindWithPriceModal; // 开售提醒提交打点
              _this23.remindMeSubmitStats({
                mobile: mobile
              });
              if (data) {
                _this23.$toast('预约成功');
                _this23.btnText = '已 预 约';
                if (_this23.saleRemindVO) {
                  _this23.saleRemindVO.register = true;
                }
              } else {
                _this23.$toast(_this23.$ERROR_TEXT);
              }
              if (!(!code || code === 200)) {
                _context20.next = 11;
                break;
              }
              if (!(_this23.isShowReminderPublic && data)) {
                _context20.next = 10;
                break;
              }
              _this23.reminderPublicModalSource = data;
              _this23.openReminderPublicModal();
              _this23.hideRemindModal();
              return _context20.abrupt("return");
            case 10:
              setTimeout(function () {
                _this23.hideRemindModal();
              }, 1200);
            case 11:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    /** 开售提醒逻辑 */
    /** 跳转路径生成 跳转的路径补上商家销售标志 salesWay */
    urlPacking: function urlPacking(link) {
      var option = {};
      if (arguments.length <= 1 ? undefined : arguments[1]) {
        option.pId = arguments.length <= 1 ? undefined : arguments[1];
      }
      if (arguments.length <= 2 ? undefined : arguments[2]) {
        option.sId = arguments.length <= 2 ? undefined : arguments[2];
      }
      if (arguments.length <= 3 ? undefined : arguments[3]) {
        option.aId = arguments.length <= 3 ? undefined : arguments[3];
      }
      var url = Url.stringify(link, option);
      return url;
    },
    // 跳转到票品选择页面
    jumpToSelectTicketsPage: function jumpToSelectTicketsPage() {
      // 已全量切至新票档模板，newTemplate字段废弃
      var _this$performanceInfo2 = this.performanceInfo,
        performanceId = _this$performanceInfo2.performanceId,
        modelStyle = _this$performanceInfo2.modelStyle;
      var url = this.urlPacking("/ticket-level?id=".concat(performanceId, "&modelStyle=").concat(modelStyle, "&isNewPage=false"));
      return url;
    },
    // 获取特权购的验证结果
    getValidateResult: function getValidateResult() {
      var _this24 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _ref7, performanceId, _yield$validateActivi, code, data, _ref8, valid;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _ref7 = _this24.performanceInfo || {}, performanceId = _ref7.performanceId;
              if (Drip.User.isLogin) {
                _context21.next = 3;
                break;
              }
              return _context21.abrupt("return");
            case 3:
              if (performanceId) {
                _context21.next = 5;
                break;
              }
              return _context21.abrupt("return");
            case 5:
              if (!(_this24.activityType !== 1)) {
                _context21.next = 7;
                break;
              }
              return _context21.abrupt("return");
            case 7:
              _context21.next = 9;
              return validateActivity(performanceId);
            case 9:
              _yield$validateActivi = _context21.sent;
              code = _yield$validateActivi.code;
              data = _yield$validateActivi.data;
              _ref8 = data || {}, valid = _ref8.valid; // 1005     "msg": "您已完成校验,请耐心等待"
              _this24.validateResult = code === 200 && !!valid || code === 1005;
            case 14:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    // 特权购url
    jumpToPrivilege: function jumpToPrivilege() {
      var _this25 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var _this25$performanceIn, performanceId, seatType, needSeat, res, code, data, msg, url, activityId, valid, beforeSaleQs;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this25$performanceIn = _this25.performanceInfo, performanceId = _this25$performanceIn.performanceId, seatType = _this25$performanceIn.seatType;
              needSeat = seatType === 1;
              _context22.next = 4;
              return validateActivity(performanceId);
            case 4:
              res = _context22.sent;
              code = res.code, data = res.data, msg = res.msg;
              if (!(code === 200)) {
                _context22.next = 20;
                break;
              }
              activityId = data.activityId, valid = data.valid;
              if (!valid) {
                _context22.next = 14;
                break;
              }
              if (!needSeat) {
                _context22.next = 11;
                break;
              }
              return _context22.abrupt("return", true);
            case 11:
              /*  如果已经校验过 */
              url = _this25.urlPacking("/ticket-good?id=".concat(performanceId, "&activityId=").concat(activityId, "&modelStyle=6"));
              _context22.next = 17;
              break;
            case 14:
              /*  如果未经校验过 */
              beforeSaleQs = '';
              if (needSeat) {
                beforeSaleQs = "&beforeSale=".concat(needSeat);
              }
              url = _this25.urlPacking("/privilege?id=".concat(performanceId, "&activityId=").concat(activityId).concat(beforeSaleQs, "&isNewPage=false"));
            case 17:
              return _context22.abrupt("return", url);
            case 20:
              if (!LIMIT_CODE.includes(code)) {
                _context22.next = 25;
                break;
              }
              _this25.$toast(_this25.$ERROR_TEXT);
              return _context22.abrupt("return", null);
            case 25:
              _this25.$toast(msg || _this25.$ERROR_TEXT);
              return _context22.abrupt("return", null);
            case 27:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    // 打开特权购
    openPrivilege: function openPrivilege(e) {
      var _this26 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var nextDestination;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return _this26.jumpToPrivilege();
            case 2:
              nextDestination = _context23.sent;
              if (nextDestination) {
                _context23.next = 5;
                break;
              }
              return _context23.abrupt("return");
            case 5:
              if (e.beforeSale) {
                // 开售前打开
                nextDestination = "".concat(nextDestination, "&beforeSale=true");
              }
              _this26.leavePage(nextDestination);
            case 7:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    /** 选座购票的相关逻辑 */reactionAccordingToShowInfoAndAreaInfo: function reactionAccordingToShowInfoAndAreaInfo() {
      var _this27 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var performanceId, showInfo, firstShowId, areaInfo, destination;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              performanceId = _this27.performanceInfo.performanceId;
              _context24.prev = 1;
              _context24.next = 4;
              return _this27.getShowInfoById(performanceId);
            case 4:
              showInfo = _context24.sent;
              if (!(showInfo.length === 1)) {
                _context24.next = 17;
                break;
              }
              if (!(showInfo[0].showStatus === 3)) {
                _context24.next = 9;
                break;
              }
              _this27.hintToSellEvent(showInfo[0].onSaleTime);
              return _context24.abrupt("return");
            case 9:
              firstShowId = showInfo[0].showId;
              _context24.next = 12;
              return _this27.getAreaInfoById(firstShowId);
            case 12:
              areaInfo = _context24.sent;
              // 根据分区信息和数量，决定跳到选座还是选区
              destination = _this27.getDestinationByAreaInfo(areaInfo, firstShowId);
              return _context24.abrupt("return", destination);
            case 17:
              // 4 大于1 ，打开场次选择弹窗, 不走跳转，返回undefined
              _this27.showInfo = showInfo;
              _this27.isShowSessionList = true;
              return _context24.abrupt("return", undefined);
            case 20:
              _context24.next = 25;
              break;
            case 22:
              _context24.prev = 22;
              _context24.t0 = _context24["catch"](1);
              return _context24.abrupt("return", undefined);
            case 25:
            case "end":
              return _context24.stop();
          }
        }, _callee24, null, [[1, 22]]);
      }))();
    },
    // 根据演出id，获取演出的场次信息
    getShowInfoById: function getShowInfoById(id) {
      var _this28 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var showInfo, code, data;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return getShowInfo(id);
            case 2:
              showInfo = _context25.sent;
              code = showInfo.code, data = showInfo.data;
              if (!LIMIT_CODE.includes(code)) {
                _context25.next = 7;
                break;
              }
              _this28.$toast(_this28.$ERROR_TEXT);
              return _context25.abrupt("return");
            case 7:
              if (!(code === 1005)) {
                _context25.next = 11;
                break;
              }
              _this28.$toast('演出信息发生变化，为您重新查询');
              setTimeout(function () {
                _this28.refresh();
              }, 2000);
              return _context25.abrupt("return");
            case 11:
              if (!(code !== 200 || !data || data.length === 0)) {
                _context25.next = 13;
                break;
              }
              throw new Error('getShowError');
            case 13:
              return _context25.abrupt("return", data);
            case 14:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    // 关闭选择场次的弹窗
    onSessionListClose: function onSessionListClose() {
      this.isShowSessionList = false;
    },
    // 选中场次
    onSessionItemSelect: function onSessionItemSelect(id) {
      var _this29 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var areaInfo, destination;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return _this29.getAreaInfoById(id);
            case 3:
              areaInfo = _context26.sent;
              // 获取分区信息
              destination = _this29.getDestinationByAreaInfo(areaInfo, id); // 根据分区信息和数量，决定跳到选座还是选区
              _this29.navigateToNextPage(destination);
              // 新选座场次点击打击
              _this29.showItemClickStats({
                selectedShowId: id
              });
              _context26.next = 11;
              break;
            case 9:
              _context26.prev = 9;
              _context26.t0 = _context26["catch"](0);
            case 11:
            case "end":
              return _context26.stop();
          }
        }, _callee26, null, [[0, 9]]);
      }))();
    },
    // 根据场次id获取分区信息
    getAreaInfoById: function getAreaInfoById(id) {
      var _this30 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var areaInfo, code, data;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return getAreaInfo(id);
            case 2:
              areaInfo = _context27.sent;
              code = areaInfo.code, data = areaInfo.data;
              if (!LIMIT_CODE.includes(code)) {
                _context27.next = 7;
                break;
              }
              _this30.$toast(_this30.$ERROR_TEXT);
              return _context27.abrupt("return");
            case 7:
              if (!(code !== 200 || !data || data.length === 0)) {
                _context27.next = 9;
                break;
              }
              throw new Error('getAreaError');
            case 9:
              return _context27.abrupt("return", data);
            case 10:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    // 通过分区分区信息，判断时跳转选择分区页面，还是选座页面
    getDestinationByAreaInfo: function getDestinationByAreaInfo(area, showId, firstBuyOrderInfo) {
      var performanceId = this.performanceInfo.performanceId;
      var destination;
      if (area.length === 1) {
        // 单分区，跳转到选座页面
        var areaId = area[0].sareaId;
        var url;
        if (firstBuyOrderInfo) {
          var buyOrderId = firstBuyOrderInfo.buyOrderId,
            buyTicketId = firstBuyOrderInfo.buyTicketId,
            buyTicketNum = firstBuyOrderInfo.buyTicketNum;
          url = "/movieshoworder/select-seats.html?buyOrderId=".concat(buyOrderId, "&buyTicketId=").concat(buyTicketId, "&buyTicketNum=").concat(buyTicketNum);
        } else {
          url = '/movieshoworder/select-seats.html';
        }
        destination = this.urlPacking(url, performanceId, showId, areaId);
        return destination;
      } else {
        // 多分区，跳转到选择区域页面
        var _url;
        if (firstBuyOrderInfo) {
          var _buyOrderId = firstBuyOrderInfo.buyOrderId,
            _buyTicketId = firstBuyOrderInfo.buyTicketId,
            _buyTicketNum = firstBuyOrderInfo.buyTicketNum;
          _url = "/movieshoworder/seat-area.html?buyOrderId=".concat(_buyOrderId, "&buyTicketId=").concat(_buyTicketId, "&buyTicketNum=").concat(_buyTicketNum);
        } else {
          _url = "/movieshoworder/seat-area.html";
        }
        destination = this.urlPacking(_url, performanceId, showId);
        return destination;
      }
    },
    /** LOL相关逻辑 **/LOLCheck: function LOLCheck(performanceId) {
      var _this31 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var res;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return validateLOL(performanceId).catch(function (e) {
                return {
                  code: -1
                };
              });
            case 2:
              res = _context28.sent;
              if (!(res.code === 200 && res.data)) {
                _context28.next = 7;
                break;
              }
              return _context28.abrupt("return", true);
            case 7:
              if ([14061, 14062, 14064, 14065, 14066].includes(res.code)) {
                // 不通过走LOL页面校验
                _this31.$toast(res.msg || '校验不通过，请完成校验！');
                setTimeout(function () {
                  window.location.href = res.data.url;
                }, 1000); // 延迟1000毫米
              } else {
                _this31.$toast(res.msg);
              }
              return _context28.abrupt("return", false);
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    /** 选座购票的相关逻辑  */
    /** 跳转到下个页面的逻辑 */
    navigateToNextPage: function navigateToNextPage(destination) {
      var _this32 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var nextDestination;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!destination) {
                _context29.next = 10;
                break;
              }
              // destination 存在的情况下才需要操作
              _this32.onSessionListClose();
              nextDestination = destination; // 1. 限流检测 todo, 后续介入，限流措施正在改版本
              // 2. 外部活动检测
              _context29.next = 5;
              return _this32.outsideActivitiesCheck(nextDestination);
            case 5:
              nextDestination = _context29.sent;
              _context29.next = 8;
              return _this32.checkIsNeedAnser(nextDestination);
            case 8:
              nextDestination = _context29.sent;
              _this32.leavePage(nextDestination);
            case 10:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    checkLimitation: function checkLimitation(destination) {
      // 检测项目是否处于限流状态
      var newDestination;
      newDestination = destination;
      return newDestination;
    },
    /** 外部活动检测逻辑 */outsideActivitiesCheck: function outsideActivitiesCheck(url) {
      var _this33 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var isDuringActivities, nextDestination;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!url) {
                _context30.next = 12;
                break;
              }
              isDuringActivities = _this33.activitiesInfo.isDuringActivities;
              if (isDuringActivities) {
                _context30.next = 6;
                break;
              }
              return _context30.abrupt("return", url);
            case 6:
              _context30.next = 8;
              return _this33.getDestinationByActivitiesInfo(url);
            case 8:
              nextDestination = _context30.sent;
              return _context30.abrupt("return", nextDestination);
            case 10:
              _context30.next = 13;
              break;
            case 12:
              return _context30.abrupt("return", undefined);
            case 13:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }))();
    },
    /** 根据外部活动状态生成url  */getDestinationByActivitiesInfo: function getDestinationByActivitiesInfo(url) {
      var _this34 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var performanceId, needParmas, checkParams, index, key, response, code, msg, data, nextDestination;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              performanceId = _this34.performanceInfo.performanceId;
              needParmas = _this34.activitiesInfo.needParmas;
              checkParams = {
                performanceId: performanceId
              };
              for (index = 0; index < needParmas.length; index++) {
                key = needParmas[index];
                checkParams[key] = _this34.$route.query[key];
              }
              _context31.prev = 4;
              _context31.next = 7;
              return checkActivityPermission(checkParams);
            case 7:
              response = _context31.sent;
              code = response.code, msg = response.msg, data = response.data;
              if (!(code === 200)) {
                _context31.next = 13;
                break;
              }
              return _context31.abrupt("return", url);
            case 13:
              if (!(code === 1406)) {
                _context31.next = 23;
                break;
              }
              if (!msg) {
                _context31.next = 20;
                break;
              }
              // msg存在，弹窗
              // 打开验证弹窗，去验证
              _this34.setPrompt({
                show: true,
                text: '去验证',
                content: msg,
                type: 'checkAnswer'
              });
              _this34.outSideCheckUrl = data.url;
              return _context31.abrupt("return", undefined);
            case 20:
              return _context31.abrupt("return", data.url);
            case 21:
              _context31.next = 35;
              break;
            case 23:
              if (!(code === 403)) {
                _context31.next = 33;
                break;
              }
              _context31.next = 26;
              return Drip.login();
            case 26:
              _this34.isLogin = true;
              _context31.next = 29;
              return _this34.getDestinationByActivitiesInfo(url);
            case 29:
              nextDestination = _context31.sent;
              return _context31.abrupt("return", nextDestination);
            case 33:
              // 其他情况
              // console.log( '验证外部活动特殊情况，应该弹msg 的 toast' ) // todo: 接入toast 时完成
              _this34.$toast(msg);
              return _context31.abrupt("return", undefined);
            case 35:
              _context31.next = 40;
              break;
            case 37:
              _context31.prev = 37;
              _context31.t0 = _context31["catch"](4);
              return _context31.abrupt("return", undefined);
            case 40:
            case "end":
              return _context31.stop();
          }
        }, _callee31, null, [[4, 37]]);
      }))();
    },
    setPrompt: function setPrompt(options) {
      var show = options.show,
        text = options.text,
        content = options.content,
        type = options.type;
      this.prompt.show = show;
      this.prompt.text = text;
      this.prompt.content = content;
      this.prompt.type = type;
    },
    onPromptConfirm: function onPromptConfirm(prompType) {
      var _this35 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var url, destination;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (prompType === 'outdated') {
                if (Drip.UA.IS_DouyinShowMicroApp) {
                  window.tt.miniProgram.switchTab({
                    url: '/pages/show/index/index'
                  });
                } else if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
                  window.xhs.miniProgram.switchTab({
                    url: '/pages/show/index/index'
                  });
                } else if (Drip.UA.IS_MAOYAN) {
                  Drip.constant.gotoShowHomeTab();
                } else if (Drip.UA.IS_MAOYAN_BAIDU_APP) {
                  window.swan.webView.switchTab({
                    url: '/pages/tabshow/index'
                  });
                }
                // go 方法来自global.mixin.js
                _this35.go(_this35.urlPacking("/"), {
                  _blank: true
                });
              }
              if (!(prompType === 'checkAnswer')) {
                _context32.next = 7;
                break;
              }
              url = _this35.outSideCheckUrl;
              _context32.next = 5;
              return _this35.checkIsNeedAnser(url);
            case 5:
              destination = _context32.sent;
              _this35.leavePage(destination);
            case 7:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    onPromptMaskClicked: function onPromptMaskClicked(type) {
      if (type === 'outdated') {
        // 项目过期状态，不允许关闭，只能重定向到首页
        return;
      }
      // reset prompt
      this.setPrompt({
        show: false,
        text: '',
        content: '',
        type: ''
      });
    },
    checkIsNeedAnser: function checkIsNeedAnser(url) {
      var _this36 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var btnType, _this36$performanceIn, performanceId, isHotProject, needAnswer, hasAnswerNewQuestion, hasAnswerNewQuestionPerformances, hasAnswerNewQuestionStorage, questionObject, response, limitResponse, _response, code, data, _needAnswer;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              // 检测项目是否需要跳转答题页面
              // 先抢逻辑优先不用答题
              btnType = _this36.btnType;
              if (!(btnType === 'xianqiang_lijiqiangzuo' && url)) {
                _context33.next = 3;
                break;
              }
              return _context33.abrupt("return", url);
            case 3:
              if (!url) {
                _context33.next = 47;
                break;
              }
              _this36$performanceIn = _this36.performanceInfo, performanceId = _this36$performanceIn.performanceId, isHotProject = _this36$performanceIn.isHotProject, needAnswer = _this36$performanceIn.needAnswer;
              if (needAnswer) {
                _context33.next = 7;
                break;
              }
              return _context33.abrupt("return", url);
            case 7:
              // 所有答题都走新答题接口
              // const isNewAnswer = isHotProject // 是否是新答题
              hasAnswerNewQuestion = false; // 是否已经答题
              _context33.next = 10;
              return Store.get('_show_hasAnswerNewQuestion');
            case 10:
              hasAnswerNewQuestionPerformances = _context33.sent;
              // 已经回答过新答题的项目
              hasAnswerNewQuestionStorage = hasAnswerNewQuestionPerformances && hasAnswerNewQuestionPerformances[performanceId]; // 该项目是的Storage存储
              // 当前项目是否答题标式符合是否已经过期
              if (hasAnswerNewQuestionStorage) {
                hasAnswerNewQuestion = hasAnswerNewQuestionStorage.timestamp + hasAnswerNewQuestionStorage.expires * 1000 > new Date();
              }
              questionObject = {}; // 答题需要的方法
              // 所有答题都走新答题接口
              questionObject = {
                getIsNeedAnswerFuction: getIsNeedAnswerNew,
                // 获取是否需要
                questionUrl: "/question-new/".concat(performanceId),
                // 答题页路径
                nextPageDestinationKey: 'seatOrTicketNew' // 储存Storage的答题页下一跳的地址
              };

              _context33.prev = 15;
              response = {};
              limitResponse = null; // 新答题且在已经答题的情况
              //
              _context33.next = 20;
              return questionObject.getIsNeedAnswerFuction(performanceId, !!hasAnswerNewQuestion);
            case 20:
              response = _context33.sent;
              limitResponse = response.data;
              response.data = {
                needAnswer: response.data
              };
              _response = response, code = _response.code, data = _response.data;
              if (!LIMIT_CODE.includes(code)) {
                _context33.next = 29;
                break;
              }
              _this36.$toast(_this36.$ERROR_TEXT);
              return _context33.abrupt("return", '');
            case 29:
              if (!(code !== 200 || !data)) {
                _context33.next = 33;
                break;
              }
              throw new Error('get answer error');
            case 33:
              _needAnswer = data.needAnswer;
              if (!_needAnswer) {
                _context33.next = 39;
                break;
              }
              setTimeout(function () {
                // 后续方法结束后再作跳转，以免内存泄漏
                Drip.setStore(questionObject.nextPageDestinationKey, encodeURI(url)).then(function () {
                  // 存储后跳转答题
                  _this36.go(
                  // go 方法来自global.mixin.js
                  _this36.urlPacking(questionObject.questionUrl), {
                    _blank: true
                  });
                }).catch(function (err) {
                  console.warn(err);
                });
              }, 100);
              return _context33.abrupt("return", undefined);
            case 39:
              return _context33.abrupt("return", url);
            case 40:
              _context33.next = 45;
              break;
            case 42:
              _context33.prev = 42;
              _context33.t0 = _context33["catch"](15);
              return _context33.abrupt("return", undefined);
            case 45:
              _context33.next = 48;
              break;
            case 47:
              return _context33.abrupt("return", undefined);
            case 48:
            case "end":
              return _context33.stop();
          }
        }, _callee33, null, [[15, 42]]);
      }))();
    },
    leavePage: function leavePage(url) {
      // 离开页面跳转
      if (url) {
        // 跳转页面时关闭限流弹窗
        this.closeLimitModal();
        if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
          if (url.includes('myshowfe')) {
            Drip.redirect(url);
            return;
          }
        }
        this.go(url, {
          _blank: true
        });
      }
    },
    // 点击预览座位图
    togglePreview: function togglePreview() {
      this.isSeatPreview = !this.isSeatPreview;
    },
    // 点击展示优惠信息
    togglePromotion: function togglePromotion() {
      if (!this.isShowPromotion) {
        this.discountClickStats();
      }
      this.isShowPromotion = !this.isShowPromotion;
    },
    // 点击展示服务标
    toggleServiceTitle: function toggleServiceTitle() {
      if (!this.isShowServiceTitle) {
        // 服务标点击打点
        this.serverTapStats();
      }
      this.isShowServiceTitle = !this.isShowServiceTitle;
    },
    // 计算展示tapStatus类型
    caculateTapStatus: function caculateTapStatus(_ref9) {
      var self = _ref9.self,
        generalAgent = _ref9.generalAgent,
        exclusive = _ref9.exclusive;
      // 非自营
      if (!self) {
        return '';
      }
      // 独家 & 总代
      if (generalAgent && exclusive) {
        return 'exclusive-agent';
      }
      // 总代
      if (generalAgent && !exclusive) {
        return 'generalAgent';
      }
      // 独家
      if (!generalAgent && exclusive) {
        return 'exclusive';
      }
    },
    // 跳转到kugou音乐h5
    goToMusic: function goToMusic(e) {
      var url = e.url;
      this.musicClickStats();
      // 原生端
      if (Drip.UA.isNative) {
        KNB.openPage({
          url: url
        });
        return;
      }
      // 网页端
      window.location.href = url;
    },
    /* *******收藏相关方法********  */
    // 计算是否收藏状态
    setCollectStatus: function setCollectStatus() {
      var _this37 = this;
      if (!this.isLogin) {
        this.isCollect = false;
      } else {
        if (!this.performanceId) return;
        getCollectState(this.performanceId).then(function (_ref10) {
          var code = _ref10.code,
            msg = _ref10.msg,
            data = _ref10.data;
          if (code === 200) {
            data !== null ? _this37.isCollect = true : _this37.isCollect = false;
          }
        }).catch(function (err) {
          console.warn(err);
        });
      }
    },
    // 点击收藏按钮触发的方法
    onCollect: function onCollect() {
      var _this38 = this;
      // m 站预览
      var isMSite = this.isMSite,
        isWxWbQQ = this.isWxWbQQ,
        performanceInfo = this.performanceInfo;
      var preview = performanceInfo.preview;
      if (isMSite && preview) {
        if (isWxWbQQ) {
          // 引导倒你普通浏览器
          this.toggleMTutorial();
        } else {
          // 展示m站跳转购票引导 引导倒app或微信小程序
          this.toggleMJumpModal();
        }
        return;
      }
      if (this.isLogin) {
        this.collect();
      } else {
        Drip.login().then(function (res) {
          _this38.isLogin = true;
          _this38.handyLoginCallback();
        }).catch(function (err) {
          console.warn(err);
        });
      }
    },
    // 收藏
    collect: function collect() {
      var _this39 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        var text, res, _ref11, code, data, msg;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              text = _this39.isCollect ? '已取消想看~' : '已标记想看~储存到“我的”';
              res = {};
              if (_this39.performanceId) {
                _context34.next = 4;
                break;
              }
              return _context34.abrupt("return");
            case 4:
              if (!_this39.isCollecting) {
                _context34.next = 6;
                break;
              }
              return _context34.abrupt("return");
            case 6:
              _this39.isCollecting = true;
              if (_this39.isCollect) {
                _context34.next = 13;
                break;
              }
              _context34.next = 10;
              return addCollect(_this39.performanceId);
            case 10:
              res = _context34.sent;
              _context34.next = 16;
              break;
            case 13:
              _context34.next = 15;
              return cancelCollect(_this39.performanceId);
            case 15:
              res = _context34.sent;
            case 16:
              _ref11 = res || {}, code = _ref11.code, data = _ref11.data, msg = _ref11.msg;
              _this39.isCollecting = false;
              if (code === 200 && data) {
                if (_this39.performanceInfo.wantToSeeCount) {
                  if (_this39.isCollect) {
                    _this39.performanceInfo.wantToSeeCount--;
                  } else {
                    _this39.performanceInfo.wantToSeeCount++;
                  }
                }
                _this39.isCollect = !_this39.isCollect;
                _this39.$toast(text, {
                  wordWrap: false
                });
              } else if (LIMIT_CODE.includes(code) || code === 1103) {
                _this39.$toast('您已经标记想看了～');
              } else {
                _this39.$toast("".concat(_this39.isCollect ? '取消' : '标记', "\u60F3\u770B\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5~"), {
                  wordWrap: false
                });
              }
              // 想看点击打点
              _this39.collectStats();
            case 20:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }))();
    },
    /* *******分享相关方法********  */
    // 获取分享内容
    caculateShareParam: function caculateShareParam(performanceInfo) {
      var self = this;
      var _Drip$UA2 = Drip.UA,
        osName = _Drip$UA2.osName,
        isNative = _Drip$UA2.isNative,
        IS_MAOYAN = _Drip$UA2.IS_MAOYAN;
      var isIos = osName.indexOf('ios') !== -1;
      var name = performanceInfo.name,
        showTimeRange = performanceInfo.showTimeRange,
        shopName = performanceInfo.shopName,
        performanceId = performanceInfo.performanceId,
        postUrlForShare = performanceInfo.postUrlForShare,
        posterUrl = performanceInfo.posterUrl;
      // 美团、点评、格瓦拉等非猫眼app分享渠道
      var channel = [KNB.share.WECHAT_FRIENDS, KNB.share.WECHAT_TIMELINE, KNB.share.WEIBO, KNB.share.QQ];
      var miniProgram = null;
      // 猫眼app内分享渠道
      if (IS_MAOYAN) {
        channel = isIos ? channel.concat(KNB.share.QZONE) : [-1];
        miniProgram = {
          type: 0,
          // 分享小程序类型，包含正式版-0、开发版-1、体验版-2，默认正式版
          id: 'gh_d9004ba7511f',
          // 标识分享的小程序，参数为小程序原始id，必填项
          path: 'pages/show/detail/index?isNewPage=false&id=' + performanceId,
          image: imgCut(posterUrl, 210, 168)
        };
      }
      var shareParam = {
        title: name,
        desc: "".concat(showTimeRange, " ").concat(shopName),
        content: name,
        url: "".concat(getDetailShareLink(performanceId), "&isNewPage=false"),
        image: postUrlForShare,
        channel: channel,
        miniProgram: miniProgram,
        success: function success() {
          // 分享给朋友事件打点
          self.shareCallBack();
          if (isNative) {
            self.shareToFriendStats();
          }
        },
        fail: function fail() {
          // 分享给朋友事件打点
          if (isNative) {
            self.shareToFriendStats();
          }
        }
      };
      this.shareOptions = shareParam;
    },
    shareCallBack: function shareCallBack() {
      var _this40 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        var requestData;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (Drip.User.isLogin) {
                _context35.next = 2;
                break;
              }
              return _context35.abrupt("return");
            case 2:
              requestData = {
                opType: 1,
                projectId: _this40.performanceInfo.performanceId,
                opObjectId: _this40.performanceInfo.performanceId
              };
              _context35.next = 5;
              return axios({
                url: "".concat(SHARE_CALLBACK, "?sellChannel=").concat(Drip.constant.appType),
                method: 'post',
                data: Object.assign({}, requestData),
                headers: {
                  'Content-type': 'application/json'
                }
              });
            case 5:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    /** *****锚点相关方法******* */
    // 计算是否展示亮点锚点
    // 计算是否展示推荐锚点
    // 获取需要展示的锚点组
    // 点击预填按钮
    prefillClick: function prefillClick() {
      this.preInputClickStats();
      this.goToCommonInfo();
    },
    // 预填曝光点
    prefillMounted: function prefillMounted() {
      try {
        window.seedAction({
          evt: 'view',
          bid: 'b_8cofnoby',
          cid: 'c_c21utqjf'
        });
      } catch (error) {}
    },
    // 点击锚点触发方法
    // 更改选中锚点
    // 滚动页面到锚点位置方法
    // 滑动页面被监听的方法
    onScroll: function onScroll() {
      var scrolled = document.documentElement.scrollTop || document.body.scrollTop;
      if (!this.isGameProject && !this.showNewPage) {
        this.toggleAnchorByScrollTop(scrolled);
        this.setSelectedAnchorByScrollTop(scrolled);
      }
      this.componentAnimation(scrolled);
      this.toggleIcon(scrolled);
    },
    toggleIcon: function toggleIcon(scrolled) {
      if (scrolled < window.screen.height) {
        this.displayGoIndex = false;
        // this.displayGoOrder = false
      } else {
        this.displayGoIndex = true;
        this.displayGoOrder = true;
      }
    },
    componentAnimation: function componentAnimation(scrollTop) {
      var _this41 = this;
      if (scrollTop > 300) {
        if (this.animateScroll) {
          return;
        }
        this.animateScroll = true;
        if (this.$refs.bombComponent) {
          this.$refs.bombComponent.hide();
          setTimeout(function () {
            _this41.showBomb = false;
          }, 400);
        }
        if (this.$refs.detailAnimationComponent) {
          this.$refs.detailAnimationComponent.show();
        }
      } else {
        if (!this.animateScroll) {
          return;
        }
        this.animateScroll = false;
        if (this.$refs.bombComponent) {
          this.showBomb = true;
          this.$nextTick(function () {
            _this41.$refs.bombComponent.show();
          });
        }
        if (this.$refs.detailAnimationComponent) {
          this.$refs.detailAnimationComponent.hide();
        }
      }
    },
    setHtmlBodyScroll: function setHtmlBodyScroll(isShow) {
      if (isShow) {
        var cssStr = 'overflow-y: hidden; height: 100%;';
        document.getElementsByTagName('body')[0].style.cssText = cssStr;
        document.body.style.cssText = cssStr;
      } else {
        var _cssStr = 'overflow-y: auto; height: auto;';
        document.getElementsByTagName('body')[0].style.cssText = _cssStr;
        document.body.style.cssText = _cssStr;
      }
    },
    // 预约公示相关
    setReminderPublic: function setReminderPublic(performanceInfo) {
      if (performanceInfo.projectReserveVO) {
        var projectReserveVO = performanceInfo.projectReserveVO;
        this.projectReserveVO = projectReserveVO;
        this.isShowReminderPublic = projectReserveVO.isDisplay;
        this.reminderPublicNumber = 0;
      }
    },
    // 如果需要现实预约公示 获取预约公示人数
    getReminderPublicNumber: function getReminderPublicNumber(performanceInfo) {
      var _this42 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        var performanceId;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              performanceId = performanceInfo.performanceId;
              if (_this42.isShowReminderPublic) {
                getReminderNumber(performanceId).then(function (res) {
                  var code = res.code,
                    data = res.data;
                  if (code === 200) {
                    if (data === -1) {
                      _this42.isShowReminderPublic = false;
                    }
                    _this42.reminderPublicNumber = data;
                    if (!_this42.countDownEnd && data <= 9999999) {
                      setTimeout(function () {
                        _this42.getReminderPublicNumber(performanceInfo);
                      }, 5000);
                    }
                  }
                }).catch(function (err) {
                  if (!_this42.countDownEnd) {
                    setTimeout(function () {
                      _this42.getReminderPublicNumber(performanceInfo);
                    }, 5000);
                  }
                  throw err;
                });
              }
            case 2:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }))();
    },
    // 关闭限流弹窗
    handleCloseLimitModal: function handleCloseLimitModal() {
      var limitType = this.limitObject.limitType;
      if (limitType === 'qrcode') {
        this.checkMSiteAndButtonRreaction();
      } else if (limitType === 'JumpModal') {
        this.toggleMJumpModal();
      } else {
        this.refresh();
      }
    },
    // 设置限流弹窗数据
    setModalLimitObject: function setModalLimitObject(code) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      try {
        this.limitCount = this.limitCount + 1;
        this.limitObject = {
          hasCountTime: code === HAS_COUNTTIME_LIMIT_CODE,
          backgroundImage: data.url2 || LimitObjectConfig.defaultLimitModalImage,
          defaultLimitTime: code === HAS_COUNTTIME_LIMIT_CODE ? data.interval || LimitObjectConfig.interval : 0,
          buttonText: data.buttonText,
          text: LIMIT_CODE.includes(code) ? data.text || LimitObjectConfig.limitContent : LimitObjectConfig.errorContent,
          limitType: type
        };
        if (this.closeLimitModalTimer) {
          clearTimeout(this.closeLimitModalTimer);
          this.closeLimitModalTimer = null;
        }
        this.showLimitingModal = true;
        this.showLimitMask = false;
      } catch (e) {}
    },
    // 设置页面限流数据
    setPageLimitObject: function setPageLimitObject(code) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        this.limitCount = this.limitCount + 1;
        this.limitObject = {
          hasCountTime: code === HAS_COUNTTIME_LIMIT_CODE,
          backgroundImage: data.url2 || LimitObjectConfig.defaultLimitModalImage,
          defaultLimitTime: code === HAS_COUNTTIME_LIMIT_CODE ? data.interval || LimitObjectConfig.interval : 0,
          buttonText: data.buttonText,
          text: LIMIT_CODE.includes(code) ? data.text || LimitObjectConfig.limitContent : LimitObjectConfig.errorContent
        };
        if (this.closeLimitPageTimer) {
          clearTimeout(this.closeLimitPageTimer);
          this.closeLimitPageTimer = null;
        }
        this.isLimitPage = true;
        this.showLimitMask = false;
      } catch (e) {}
    },
    closeLimitPage: function closeLimitPage() {
      var _this43 = this;
      this.showLimitMask = true;
      this.closeLimitPageTimer = null;
      this.closeLimitPageTimer = setTimeout(function () {
        _this43.isLimitPage = false;
        _this43.showLimitMask = false;
      }, 300);
    },
    closeLimitModal: function closeLimitModal() {
      var _this44 = this;
      this.showLimitMask = true;
      this.closeLimitModalTimer = null;
      this.closeLimitModalTimer = setTimeout(function () {
        _this44.showLimitingModal = false;
        _this44.showLimitMask = false;
      }, 300);
    },
    // 打开预约公示浮层
    openReminderPublicModal: function openReminderPublicModal() {
      this.isShowReminderPublicModal = true;
    },
    // 关闭预约公示浮层
    closeReminderPublicModal: function closeReminderPublicModal() {
      this.isShowReminderPublicModal = false;
    },
    closePoolShowListModal: function closePoolShowListModal() {
      this.showListModal = false;
    },
    /**
    * 统一打点方法，请在这里定义，也请调用这里的方法去处理打点
    * @param {String} type 打点类型
    * @param {object} options 附带信息 val_lab
    */
    statsHandler: function statsHandler(type, options) {
      var self = this;
      var handlers = {
        // 想看点击打点
        collectStats: function collectStats() {
          window.seedAction(Object.assign({
            bid: 'b_ye0v08k2',
            evt: 'click',
            abtest: self.showNewPage ? 1 : 0
          }, self.customStatusObject, {
            needTag: true
          }));
        },
        // 分享给朋友事件打点
        shareToFriendStats: function shareToFriendStats() {
          window.seedAction(Object.assign({
            bid: 'b_imlgaynr',
            evt: 'click'
          }, self.customStatusObject, {
            needTag: true
          }));
        },
        couponAbtest: function couponAbtest(options) {
          window.seedAction({
            bid: 'b_movie_72anbob0_mv',
            evt: 'view',
            custom: Object.assign({}, self.customStatusObject, options, {
              custom: Object.assign({}, self.customStatusObject, options)
            })
          });
        },
        // 优惠区点击打点
        discountClickStats: function discountClickStats(options) {
          window.seedAction(Object.assign({
            bid: 'b_ihmrott8',
            evt: 'click'
          }, self.customStatusObject, options, {
            abtest: self.showNewPage ? 1 : 0
          }));
        },
        // 预填点击打点
        preInputClickStats: function preInputClickStats() {
          window.seedAction(Object.assign({
            bid: 'b_bnguyfls',
            evt: 'click'
          }, self.customStatusObject, {
            needTag: true
          }));
        },
        // 开售提醒点击打点
        onSaleRemindMeClick: function onSaleRemindMeClick(options) {
          window.seedAction(Object.assign({
            bid: 'b_5gl7ntou',
            evt: 'click'
          }, self.customStatusObject, {
            abtest: self.showNewPage ? 1 : 0
          }, options));
        },
        // 开售提醒提交打点
        remindMeSubmitStats: function remindMeSubmitStats(options) {
          window.seedAction(Object.assign({
            bid: 'b_id5bevfv',
            evt: 'click'
          }, self.customStatusObject, options));
        },
        // 立即预订打点
        bookTicketsNowStatus: function bookTicketsNowStatus(options) {
          window.seedAction(Object.assign({
            bid: 'b_q4joxr1s',
            evt: 'click'
          }, self.customStatusObject, options, {
            needTag: true
          }));
        },
        // 立即购票打点
        buyTicketsNowStats: function buyTicketsNowStats() {
          window.seedAction(Object.assign({
            bid: 'b_b9fd4le0',
            evt: 'click'
          }, self.customStatusObject, {
            needTag: true
          }));
        },
        // 选座购票点击打点
        selectSeatBuyTickets: function selectSeatBuyTickets() {
          window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_fzzpqaym', Object.assign({}, self.customStatusObject));
          window.seedAction({
            bid: 'b_fzzpqaym',
            evt: 'click',
            custom: {
              custom: Object.assign({}, self.customStatusObject)
            }
          });
        },
        // 新选座，多场次点击打点
        showItemClickStats: function showItemClickStats(options) {
          window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_tkfpmsym', Object.assign({}, self.customStatusObject, options));
          window.seedAction({
            bid: 'b_tkfpmsym',
            evt: 'click',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, self.customStatusObject, options)
            })
          });
        },
        // 点击为你推荐打点
        onRecommandClick: function onRecommandClick(options) {
          window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_ie7q7zy7_mc', Object.assign({}, self.customStatusObject, options));
          window.seedAction({
            bid: 'b_movie_ie7q7zy7_mc',
            evt: 'click',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, self.customStatusObject, options)
            })
          });
        },
        // 服务标点击打点
        serverTapStats: function serverTapStats() {
          window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_0dbmwuju_mc', Object.assign({}, self.customStatusObject, {
            abtest: self.showNewPage ? 1 : 0
          }));
          window.seedAction({
            bid: 'b_movie_0dbmwuju_mc',
            evt: 'click',
            custom: {
              abtest: self.showNewPage ? 1 : 0,
              custom: Object.assign({}, self.customStatusObject)
            }
          });
        },
        // 演出亮点展示打点
        lightViewStats: function lightViewStats() {
          window.seedAction({
            bid: 'b_movie_t3h47x1a_mv',
            evt: 'view',
            custom: {
              custom: Object.assign({}, self.customStatusObject)
            }
          });
        },
        // 演出现场展示打点
        videoListViewStats: function videoListViewStats() {
          if (self.showNewPage) {
            window.seedAction({
              evt: 'view',
              bid: 'b_movie_6id8y3ve_mv',
              cid: 'c_c21utqjf',
              abtest: 1,
              custom: {
                performance_id: self.performanceId
              }
            });
          } else {
            window.seedAction({
              bid: 'b_movie_ro4rfzn1_mv',
              evt: 'view',
              custom: {
                custom: Object.assign({}, self.customStatusObject)
              }
            });
          }
        },
        // 点击视频或者剧照点击打点
        videoOrPhotoClickStats: function videoOrPhotoClickStats() {
          if (self.showNewPage) {
            window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_6id8y3ve_mc', {
              performance_id: self.performanceId,
              abtest: 1
            });
            window.seedAction({
              evt: 'click',
              bid: 'b_movie_6id8y3ve_mc',
              cid: 'c_c21utqjf',
              abtest: 1,
              custom: {
                performance_id: self.performanceId
              }
            });
          } else {
            window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_maves5z5_mc', Object.assign({}, self.customStatusObject));
            window.seedAction({
              bid: 'b_movie_maves5z5_mc',
              evt: 'click',
              custom: {
                custom: Object.assign({}, self.customStatusObject)
              }
            });
          }
        },
        // 酷狗音乐模块展示打点
        musicViewStats: function musicViewStats() {
          window.seedAction({
            bid: 'b_movie_vcwk1na8_mv',
            evt: 'view',
            custom: {
              custom: Object.assign({}, self.customStatusObject)
            }
          });
        },
        // 酷狗音乐模块点击打点
        musicClickStats: function musicClickStats() {
          window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_vcwk1na8_mc', Object.assign({}, self.customStatusObject));
          window.seedAction({
            bid: 'b_movie_vcwk1na8_mc',
            evt: 'click',
            custom: {
              custom: Object.assign({}, self.customStatusObject)
            }
          });
        },
        // 触发展示更多的图片时打点
        photoMoreClickStats: function photoMoreClickStats() {
          if (self.showNewPage) {
            window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_6id8y3ve_mc', {
              performance_id: self.performanceId,
              abtest: 1
            });
            window.seedAction({
              evt: 'click',
              bid: 'b_movie_6id8y3ve_mc',
              cid: 'c_c21utqjf',
              abtest: 1,
              custom: {
                performance_id: self.performanceId
              }
            });
          } else {
            window.lxTagReport && window.lxTagReport('c_c21utqjf', 'b_movie_v4htoz7m_mc', Object.assign({}, self.customStatusObject));
            window.seedAction({
              bid: 'b_movie_v4htoz7m_mc',
              evt: 'click',
              custom: {
                custom: Object.assign({}, self.customStatusObject)
              }
            });
          }
        }
      };
      var handler = handlers[type];
      if (handler) {
        try {
          handler(options);
        } catch (e) {
          console.log('e', e);
        }
      }
    },
    /* *******打点相关方法********  */
    // 想看点击打点
    collectStats: function collectStats() {
      this.statsHandler('collectStats');
    },
    // 分享给朋友事件打点
    shareToFriendStats: function shareToFriendStats() {
      this.statsHandler('shareToFriendStats');
    },
    // 优惠区点击打点
    discountClickStats: function discountClickStats() {
      var saleStatus = this.saleStatus;
      var options = {
        saleStatus: saleStatus
      };
      this.statsHandler('discountClickStats', options);
    },
    // 预填点击打点
    preInputClickStats: function preInputClickStats() {
      this.statsHandler('preInputClickStats');
    },
    // 开售提醒点击打点
    onSaleRemindMeClick: function onSaleRemindMeClick() {
      var mistiming = this.mistiming;
      var now = new Date().getTime() - mistiming;
      var options = {
        phonenumber: this.remindNumber,
        time: now
      };
      this.statsHandler('onSaleRemindMeClick', options);
    },
    // 开售提醒提交打点
    remindMeSubmitStats: function remindMeSubmitStats(option) {
      var remindNumber = option.remindNumber;
      this.statsHandler('remindMeSubmitStats', {
        phonenumber: remindNumber
      });
    },
    // 立即预订打点
    bookTicketsNowStatus: function bookTicketsNowStatus() {
      this.statsHandler('bookTicketsNowStatus', {
        abtest: this.showNewPage ? 1 : 0
      });
    },
    // 立即购票打点
    buyTicketsNowStats: function buyTicketsNowStats() {
      this.statsHandler('buyTicketsNowStats');
    },
    // 选座购票点击打点
    selectSeatBuyTickets: function selectSeatBuyTickets() {
      this.statsHandler('selectSeatBuyTickets');
    },
    // 新选座，多场次点击打点
    showItemClickStats: function showItemClickStats(option) {
      this.statsHandler('showItemClickStats', option);
    },
    // 为你推荐点击打点
    onRecommandClick: function onRecommandClick(e) {
      this.statsHandler('onRecommandClick', {
        performanceId: e.performanceid
      });
    },
    // 服务标点击打点
    serverTapStats: function serverTapStats() {
      this.statsHandler('serverTapStats');
    },
    // 演出亮点展示打点
    lightViewStats: function lightViewStats() {
      this.statsHandler('lightViewStats');
    },
    // 演出现场展示打点
    videoListViewStats: function videoListViewStats() {
      this.statsHandler('videoListViewStats');
    },
    // 点击视频或者剧照点击打点
    videoOrPhotoClickStats: function videoOrPhotoClickStats() {
      this.statsHandler('videoOrPhotoClickStats');
    },
    // 酷狗音乐模块展示打点
    musicViewStats: function musicViewStats() {
      this.statsHandler('musicViewStats');
    },
    // 酷狗音乐模块点击打点
    musicClickStats: function musicClickStats() {
      this.statsHandler('musicClickStats');
    },
    // 触发展示更多的图片时打点
    photoMoreClickStats: function photoMoreClickStats() {
      this.statsHandler('photoMoreClickStats');
    },
    gotoDetailTab: function gotoDetailTab() {
      // 详情收起后滚动到详情标题位置
      var ele = document.getElementById('light-content');
      if (!ele) return;
      var _ele$getBoundingClien = ele.getBoundingClientRect(),
        top = _ele$getBoundingClien.top;
      window.scrollBy({
        top: top - 50,
        behavior: 'instant'
      });
    },
    /**
     * 演出自定义数据上报
     */
    showDetailPv: function showDetailPv() {
      var _this45 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var utmSource, projectId, visitTime, _Drip$constant, sellChannel, _Drip$constant$userId, userId, _Drip$constant$mobile, mobile, _Drip$constant$cityId, cityId, unionId, appName, cid, body;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              utmSource = Url.getQuery('utm_source') || Url.getHashQuery('utm_source') || '';
              if (utmSource.startsWith('MYYCTF')) {
                _context37.next = 3;
                break;
              }
              return _context37.abrupt("return");
            case 3:
              projectId = _this45.performanceIdByRoute;
              visitTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
              _Drip$constant = Drip.constant, sellChannel = _Drip$constant.sellChannel, _Drip$constant$userId = _Drip$constant.userId, userId = _Drip$constant$userId === void 0 ? 0 : _Drip$constant$userId, _Drip$constant$mobile = _Drip$constant.mobile, mobile = _Drip$constant$mobile === void 0 ? '' : _Drip$constant$mobile, _Drip$constant$cityId = _Drip$constant.cityId, cityId = _Drip$constant$cityId === void 0 ? 10 : _Drip$constant$cityId;
              _context37.next = 8;
              return Drip.getUuid();
            case 8:
              unionId = _context37.sent;
              appName = Drip.constant.uaInfo.appName;
              cid = 'c_c21utqjf';
              body = {
                visitTime: visitTime,
                unionId: unionId,
                cityId: cityId,
                utmSource: utmSource,
                sellChannel: sellChannel,
                appName: appName,
                projectId: projectId,
                userId: userId,
                mobile: mobile,
                cid: cid,
                bid: '',
                orderId: 0
              };
              statsPvReport(body);
            case 13:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }))();
    }
  },
  computed: {
    // TODO: 同步到mweb 页面改动
    showWantToSeeBtn: function showWantToSeeBtn() {
      return this.showNewPage;
    },
    tabList: function tabList() {
      var list = [{
        id: 'project-detail',
        name: '介绍'
      }, {
        id: 'project-notes',
        name: '须知'
      }, {
        id: 'project-recommend',
        name: '推荐'
      }];
      var _ref12 = this.commentInfo || {},
        commentList = _ref12.commentList;
      // 热评
      if (commentList && commentList.length > 0) {
        if (this.showNewPage) {
          return [{
            id: 'project-detail',
            name: '介绍'
          }, {
            id: 'project-comment',
            name: '评价'
          }, {
            id: 'project-notes',
            name: '须知'
          }, {
            id: 'project-recommend',
            name: '推荐'
          }];
        } else {
          list.unshift({
            id: 'project-comment',
            name: '评价'
          });
        }
      }
      if (!this.showNewPage && this.performanceInfo && this.performanceInfo.showCoupon) {
        list.unshift({
          id: 'project-discount',
          name: '优惠'
        });
      }
      return list;
    },
    fromsearch: function fromsearch() {
      return location.href.includes('fromSearch=true');
    },
    // 判断是否是二维码进入且没有自销渠道
    isShowHome: function isShowHome() {
      var isShow = false;
      // 判断是否有路由
      var pathName = window.previousUrlObject.name;
      // 判断是否有referrer
      var pathReferrer = window.referrer;
      // 判断是否是自销
      //商家自销（非主办自销）已下架，为保险先注释，没问题后可删
      // const salesWay = Drip.constant.search.salesWay
      if (!pathName && !pathReferrer && !Drip.UA.isNative) {
        // && !salesWay
        isShow = true;
      }
      return isShow;
    },
    performanceIdByRoute: function performanceIdByRoute() {
      var performanceId = +this.$route.params.performanceId;
      if (isNaN(performanceId)) {
        performanceId = +this.$route.params.performanceId.match(/\d+/)[0];
      }
      return performanceId;
    },
    performanceId: function performanceId() {
      return this.performanceInfo.performanceId;
    },
    leftBackCloseWebview: function leftBackCloseWebview() {
      return this.closeWebview;
    },
    // 开售提醒号码是否能被提交
    canRemindNumberSubmit: function canRemindNumberSubmit() {
      var isNeedRemindWithPriceModal = this.isNeedRemindWithPriceModal,
        remindTicketPriceList = this.remindTicketPriceList; // 根据是否需要展示票档来得出不同的结果
      var reg = /1[0-9]{10}/;
      var numberPassed = reg.test(this.remindNumber);
      if (!isNeedRemindWithPriceModal) {
        // 无票档
        return numberPassed;
      } else {
        // 有票档
        // 判断pricelist长度 , 长度为0则与没有票档一样，长度不为0，则与需要判断是否有票档被选中
        if (remindTicketPriceList.length === 0) {
          return numberPassed;
        } else {
          var selected = 0;
          for (var index = 0; index < remindTicketPriceList.length; index++) {
            var element = remindTicketPriceList[index];
            if (element.selected) {
              selected += 1;
            }
          }
          var priceTagSelected = selected > 0;
          return numberPassed && priceTagSelected;
        }
      }
    },
    // 销s售方式
    saleType: function saleType() {
      var saleStatus = this.saleStatus;
      if (saleStatus === 7 || saleStatus === 8 || saleStatus === 9 || saleStatus === 10 || saleStatus === 11 || saleStatus === 12) {
        return 'firstBuyFirstGet';
      }
      if (saleStatus === 1 || saleStatus === 2 || saleStatus === 3 || saleStatus === 4 || saleStatus === 5 || saleStatus === 6 || saleStatus === 13) {
        return 'normal';
      }
      return 'unknown';
    },
    // 是否是游戏剧场项目
    isGameProject: function isGameProject() {
      return this.performanceInfo && this.performanceInfo.categoryId === 14;
    },
    canShowTimeClick: function canShowTimeClick() {
      return ['lijigoupiao', 'lijiyuding', 'xuanzuogoupiao', 'bufenyanqiquxiao'].includes(this.btnType);
    }
  },
  watch: {
    saleRemind: {
      handler: function handler(val) {
        val.isSubmitable = val.phone.length === 11;
        return val;
      },
      deep: true
    },
    shareOptions: function shareOptions(val) {
      (val || {}).title && KNB.configShare(val);
    },
    // 美团安卓大搜返回问题处理
    leftBackCloseWebview: function leftBackCloseWebview(val) {
      val && KNB.setLLButton({
        type: 'base64',
        icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAAH7+Yj7AAAAAXNSR0IArs4c6QAAAjlJREFUWAnNlz1OwzAUx5PwIW7Q9giM3KDtAYCFE4DUAyAhYEhbBooY2LuwsCCxgJhRewMOwdCeAYbwXqRnxfGzG380iRfHz+/9/I/jPNtRVHeZTCaZNOZmA7gnUkixoYQXO/G5BgfrIZ0D4GVm5WBsS/ODTnEcH3KOwoZO0+n0XRi4h3BOSAea/Om5IcGW9Hq9/arO0Xw+36vfOdZoF2aQhF/qGj7Ex3g8PhUdmoddjT0qgTYOTBwF6ApSgL4gAQwFIiAunBQbWZadkNGnFpONi2y1Wv0iDFQLuy1cCfQFK0BS5ArWAl3BOxRoqmFOs+Fw+LNYLL5Nftgn5TrOGWFo73Q6L1x/2WZ8ZYJhThqNRn/lYK6tBbrAcAAW6ApjgT4wBegLk4AhYAIYCpYDQ8IQSAv7seo6wyBTSXDzAYcr2OjvTY5V+3aWy+XrYDA4ggR70e/3D6D9VTWY88uTA0HBwRsqsk0oqACi/BBQCRgCqgB9oSzQB8qmLwRSwYMo7tmwXo/hsPRJdl29EagLLNrh981PaGRLkuQ8TdNnavvUXgLLwvAv7na7Z6HSAr6Yk8A6hNGsWwmsU5iVwCaEVRLYpDCjwDYIYwW2SZgksI3ChEAQJ+7828hjNJBrTUekPB63ILjl3bnCthGX50G8zK3X67fivRZmcwZ75e02BrVhSomaEwqwB1gGNzbQkL6SQAK3SSgrsE1CjQLbILSSwCaFWglsQqiTwDqFegnUCYUj/yUc+Z+o36f+B6I+krwsOWm/AAAAAElFTkSuQmCC',
        handle: function handle() {
          KNB.closeWebview({});
        }
      });
    },
    isShowPromotion: function isShowPromotion(newStatus) {
      this.setHtmlBodyScroll(newStatus);
    },
    isShowServiceTitle: function isShowServiceTitle(newStatus) {
      this.setHtmlBodyScroll(newStatus);
    }
  },
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      self.throttleOnscroll = throttle(this.onScroll, 300);
      window.addEventListener('scroll', self.throttleOnscroll);
    });
    this.showDetailPv();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.throttleOnscroll, false);
    KNB.unsubscribe({
      action: 'appear'
    });
    this.pageUnMounted = true;
    this.clearOnSaleInterval();
    this.countDownEnd = true;
  },
  // TODO 当改会/detail/  路径的时候要把detail-new 改回 detail
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    next();
    // 非native页面使用router.push情况跳转时候强制刷新页面
    if (/detail\/[0-9]\d*/.test(to.path) && !Drip.UA.isNative) {
      window.location.reload();
    }
  }
};